window.theme = window.theme || {};

var arrWishLists = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];
localStorage.setItem('items', JSON.stringify(arrWishLists));
if (arrWishLists.length) {
    arrWishLists = JSON.parse(localStorage.getItem('items'));
};
var doc = $(document);
var RoarCookie = {
    cookie: {
        rtread: function(d) {
            try {
                return localStorage.getItem(d)
            } catch (e) {
                return null
            }
        },
        rtwrite: function(d, e) {
            try {
                localStorage.setItem(d, e)
            } catch (f) {}
        },
        destroy: function(d) {
            try {
                localStorage.setItem(d, null)
            } catch (e) {}
        }
    }
};
var univer = {
    univerTimeout: null,
    init: function() {

        this.clickedProductTabs();
        this.initColorSwatch();
        this.scrollToTop();
        this.wishListIcons();
        this.doActionWishlish();
        if ($('body').hasClass('template-page') && $('.wishlist-page').length) {
            this.pageWishLists();
        };
        this.handleCompare();
        this.qtyMinusPlus();
        this.quickviewButton();        
        this.instagramFeedSlider();
        this.instagramFeedGrid();
    },

    instagramFeedGrid: function() {
        var instagramBlock = $('[data-instagram-grid]');
        instagramBlock.each(function() {
            var self = $(this),
                dataResolutionImages = self.data('resolution-images'),
                dataRows = self.data('vkrows'),
                dataShow = self.data('show'),
                dataLimit = self.data('limit'),
                accessToken = self.data('accesstoken'),
                vkid = self.data('vkid');

            var feed = new Instafeed({
                get: "user",
                userId: vkid,
                accessToken: accessToken,
                resolution: dataResolutionImages,
                clientId: "c6e4c736e82345a3898a0e299daa00fb",
                get limit() {
                    return limit = parseInt(dataLimit.toString());
                },
                template: '<div class="item"><div class="vk-img-wrapper"><a href="\{\{link\}\}" target="_blank"><img data-src="\{\{image\}\}" class="lazyload" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto" alt="\{\{caption\}\}" /></a></div></div>',
                after: function() {
                    self.find('a').attr({
                        target: "_blank"
                    });
                }
            });

            feed.run();
        });
    },

    instagramFeedSlider: function() {
        var instagramBlock = $('[data-instagram-feed]');
        instagramBlock.each(function() {
            var self = $(this),
                dataResolutionImages = self.data('resolution-images'),
                dataRows = self.data('vkrows'),
                dataShow = self.data('show'),
                dataLimit = self.data('limit'),
                accessToken = self.data('accesstoken'),
                vkid = self.data('vkid'),
                showarrow = self.data('showarrow'),
                autoplay = self.data('autoplay');

            var feed = new Instafeed({
                get: "user",
                userId: vkid,
                accessToken: accessToken,
                resolution: dataResolutionImages,
                clientId: "c6e4c736e82345a3898a0e299daa00fb",
                get limit() {
                    return limit = parseInt(dataLimit.toString());
                },
                template: '<div class="item"><div class="vk-img-wrapper"><a href="\{\{link\}\}" target="_blank"><img data-src="\{\{image\}\}" class="lazyload" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto" alt="\{\{caption\}\}" /></a></div></div>',
                after: function() {
                    self.find('a').attr({
                        target: "_blank"
                    });
                    self.slick({
                        infinite: true,
                        speed: 1000,
                        arrows: showarrow,
                        autoplay: autoplay,
                        slidesToShow: dataShow,
                        slidesToScroll: dataShow,
                        rows: dataRows,
                        responsive: [{
                                breakpoint: 1200,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 1,
                                }
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    slidesToShow: 4,
                                    slidesToScroll: 4,
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 3,
                                    slidesToScroll: 3,
                                }
                            }
                        ]
                    });
                }
            });

            feed.run();
        });
    },
    quickviewButton: function() {
        var e = e || "body",
            t = "";
        jQuery(e).find(".quickview .quick_view").magnificPopup({
            type: "ajax",
            preloader: !0,
            tLoading: "",
            mainClass: "quickview",
            removalDelay: 200,
            gallery: {
                enabled: !1
            },
            callbacks: {
                open: function() {
                    0 < $("#main").next(".product-360-view-wrapper").length && $("#main").next(".product-360-view-wrapper").remove()
                },
                ajaxContentAdded: function() {

                    var t = new theme.Sections;
                    t.register("product-quickview-template", theme.Product), Shopify.PaymentButton.init();
                    $('.slider-for').slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        fade: true,
                        asNavFor: '.slider-nav'
                    });
                    $('.slider-nav').slick({
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        asNavFor: '.slider-for',
                        dots: false,
                        arrows: false,
                        focusOnSelect: true,
                        responsive: [{
                            breakpoint: 576,
                            settings: {
                                verticalSwiping: false,
                                vertical: false,
                                arrows: false,
                            }
                        }, ],
                    });

                },
                beforeClose: function() {
                    0 < $(".quickview._reopen").length && "" != $(".quickview._reopen").data("_qid") && (t = $(".quickview._reopen").data("_qid"))
                },
                afterClose: function() {
                    "" != t && ($(t).trigger("click"), t = "")
                }
            }
        });
    },
    qtyMinusPlus: function() {
        var i = jQuery('.quantity');
        i.on("click", ".plus, .minus", function() {
            var t = jQuery(this),
                e = t.closest(".quantity").find(".qty"),
                i = parseFloat(e.val()),
                o = parseFloat(e.attr("max")),
                r = parseFloat(e.attr("min")),
                a = e.attr("step");
            i && "" !== i && "NaN" !== i || (i = 0), "" !== o && "NaN" !== o || (o = ""), "" !== r && "NaN" !== r || (r = 0), "any" !== a && "" !== a && void 0 !== a && "NaN" !== parseFloat(a) || (a = 1), t.is(".plus") ? o && (o === i || i > o) ? e.val(o) : e.val(i + parseFloat(a)) : r && (r === i || i < r) ? e.val(r) : i > 0 && e.val(i - parseFloat(a)), e.trigger("change")
        });

    },

    handleCompare: function() {
        "1" == univer.handleCompareEvent(), univer.autoloadCompare(), univer.handleCompareScroll()
    },
    handleCompareEvent: function() {
        var e = $("body"),
            t = $("a.add_to_compare");
        e.on("click", "a.add_to_compare", function() {
            var e = $(this),
                t = e.data("pid"),
                a = "",
                o = RoarCookie.cookie.rtread("rt-compare");
            if (o = null != o && "" != o ? o.split(",") : [], 0 > o.indexOf(t) && !1 === $(this).hasClass("added")) {
                o.push(t);
                var r = o.join(",");
                "," == r.substring(0, 1) && (r = r.substring(1)), RoarCookie.cookie.rtwrite("rt-compare", r)
            }!1 === $(this).hasClass("added") || "" === a ? (a = "", $.ajax({
                url: "/search?view=compare&q=" + o,
                dataType: "html",
                type: "GET",
                success: function(e) {
                    a = e
                },
                error: function() {
                    console.log("ajax error")
                },
                complete: function() {
                    $.magnificPopup.open({
                        items: {
                            src: a,
                            type: "inline"
                        },
                        preloader: !0,
                        tLoading: "",
                        mainClass: "quickview compareview",
                        removalDelay: 200,
                        gallery: {
                            enabled: !0
                        },
                        callbacks: {
                            open: function() {
                                $("[data-pid=\"" + t + "\"]").addClass("added").attr("title", $("[data-pid=\"" + t + "\"]").attr("data-added")), $("[data-pid=\"" + t + "\"]").find("span").html($("[data-pid=\"" + t + "\"]").attr("data-add")), window.show_multiple_currencies && theme.CurrencyPicker.convert(".compare-content .money"), univer.handleCompareScroll()
                            }
                        }
                    })
                }
            })) : $.ajax({
                url: "/search?view=compare&q=" + o,
                dataType: "html",
                type: "GET",
                success: function(e) {
                    a = e
                },
                error: function() {
                    console.log("ajax error")
                },
                complete: function() {
                    $.magnificPopup.open({
                        items: {
                            src: a,
                            type: "inline"
                        },
                        preloader: !0,
                        tLoading: "",
                        mainClass: "quickview compareview",
                        removalDelay: 200,
                        gallery: {
                            enabled: !0
                        },
                        callbacks: {
                            open: function() {
                                window.show_multiple_currencies && theme.CurrencyPicker.convert(".compare-content .money"), univer.handleReviews(), univer.handleCompareScroll()
                            }
                        }
                    })
                }
            })
        }), e.on("click", ".remove_from_compare", function(e) {
            e.preventDefault();
            var t = $(this),
                a = t.attr("data-rev"),
                o = $(".compare-content");
            $("[data-pid=\"" + a + "\"]").removeClass("added").attr("title", $("[data-pid=\"" + a + "\"]").attr("data-add")), $("[data-pid=\"" + a + "\"]").find("span").html($("[data-pid=\"" + a + "\"]").attr("data-add"));
            var r = decodeURI(RoarCookie.cookie.rtread("rt-compare"));
            null != r && (r = r.split(",")), r = jQuery.grep(r, function(e) {
                return e != a
            }), r = $.trim(r), RoarCookie.cookie.rtwrite("rt-compare", r), $(".niparis_" + a).remove(), 0 >= r.length && $(".mfp-close").trigger("click")
        })
    },
    autoloadCompare: function() {
        if (0 != parseInt(theme.compare)) {
            var e = RoarCookie.cookie.rtread("rt-compare");
            null == e ? e = [] : (e = e.split(","), e.map(function(e) {
                $("[data-pid=\"" + e + "\"]").addClass("added").attr("title", $("[data-pid=\"" + e + "\"]").attr("data-added")), $("[data-pid=\"" + e + "\"]").find("span").html($("[data-pid=\"" + e + "\"]").attr("data-added"))
            }))
        }
    },
    handleCompareScroll: function() {
        jQuery("#uni_compare_features_table").on("scroll", function() {
                var e = jQuery(this).parent();
                jQuery(this).scrollLeft() + jQuery(this).innerWidth() >= jQuery(this)[0].scrollWidth ? e.hasClass("scroll-right") && e.removeClass("scroll-right") : 0 === jQuery(this).scrollLeft() ? e.hasClass("scroll-left") && e.removeClass("scroll-left") : (!e.hasClass("scroll-right") && e.addClass("scroll-right"), !e.hasClass("scroll-left") && e.addClass("scroll-left"))
            }), be_compare_container = document.getElementById("uni_compare_features_table"),
            null !== be_compare_container && be_compare_container.offsetWidth < be_compare_container.scrollWidth && !jQuery("#uni_compare_features_table_inner").hasClass("scroll-right") && jQuery("#uni_compare_features_table_inner").addClass("scroll-right"),
            jQuery(window).on("resize", function() {

            }), jQuery("#uni_compare_features_table_inner").hasClass("scroll-left") || jQuery("#uni_compare_features_table_inner").hasClass("scroll-right") ? $(".compareview").addClass("no-flex") : $(".compareview").removeClass("no-flex")
    },
    wishListTempItem: function(ProductHandle) {
        var wishListCotainer = $('[data-wishlist-container]');

        jQuery.getJSON('/products/' + ProductHandle + '.js', function(product) {

            var productHTML = '',
                price_min = Shopify.formatMoney(product.price_min, window.money_format);

            productHTML += '<div class="grid-item" data-wishlist-added="wishlist-' + product.id + '">';
            productHTML += '<div class="inner product-item row" data-product-id="product-' + product.handle + '">';
            productHTML += '<div class="column col-img col-md-2"><div class="product-image">';
            productHTML += '<a href="' + product.url + '" class="product-grid-image" data-collections-related="/collections/all?view=related">';
            productHTML += '<img src="' + product.featured_image + '" alt="' + product.featured_image.alt + '">';
            productHTML += '</a></div></div>';
            productHTML += '<div class="column col-prod col-md-4">';
            productHTML += '<a class="product-title" href="' + product.url + '" title="' + product.title + '">' + product.title + '</a>';
            productHTML += '<div class="product-vendor">';
            productHTML += '<a href="/collections/vendors?q=' + product.vendor + '" title="' + product.vendor + '">' + product.vendor + '</a></div></div>';
            productHTML += '<div class="column col-price text-center col-md-2"><div class="price-box">' + price_min + '</div></div>';
            productHTML += '<div class="column col-remove text-center col-md-1"><a class="whislist-added" href="#" data-product-handle="' + product.handle + '" data-icon-wishlist data-id="' + product.id + '"><span class="uni-icomoon icon-remove"></span></a></div>';
            productHTML += '<div class="column col-options text-center col-md-3">';
            productHTML += '<form action="/cart/add" method="post" class="variants" id="wishlist-product-form-' + product.id + '" data-id="product-actions-' + product.id + '" enctype="multipart/form-data">';

            if (product.available) {
                if (product.variants.length == 1) {
                    productHTML += '<button data-btn-addToCart class="btn add-to-cart-btn" data-form-id="#wishlist-product-form-' + product.id + '" type="submit">' + theme.strings.addToCart + '</button><input type="hidden" name="id" value="' + product.variants[0].id + '" />';
                }
                if (product.variants.length > 1) {
                    productHTML += '<a class="btn" title="' + product.title + '" href="' + product.url + '">' + theme.strings.select_options + '</a>';
                }
            } else {
                productHTML += '<button class="btn add-to-cart-btn" type="submit" disabled="disabled">' + theme.strings.unavailable + '</button>';
            }

            productHTML += '</form></div>';
            productHTML += '</div></div>';

            wishListCotainer.append(productHTML);

            univer.doActionWishlish();
            var regex = /(<([^>]+)>)/ig;
            var href = $('.wrapper-wishlist a.share').attr("href");
            href += encodeURIComponent(product.title + '\nPrice: ' + price_min.replace(regex, "") + '\nLink: ' + window.location.protocol + '//' + window.location.hostname + product.url + '\n\n');
            $('.wrapper-wishlist a.share').attr("href", href);
        });
    },

    pageWishLists: function() {
        if (typeof(Storage) !== 'undefined') {
            var data = JSON.parse(localStorage.getItem('items'));
            if (data.length <= 0) {
                return;
            }
            data.forEach(function(item) {
                univer.wishListTempItem(item);
            });

        } else {
            alert('Sorry! No web storage support..');
        }
    },

    addedWishlist: function(ProductHandle) {
        var wishlistElm = $('[data-product-handle="' + ProductHandle + '"]'),
            idxArr = arrWishLists.indexOf(ProductHandle);

        if (idxArr >= 0) {
            wishlistElm.addClass('whislist-added');
            wishlistElm.find('.tooltip').text(theme.strings.remove_wishlist);
        } else {
            wishlistElm.removeClass('whislist-added');
            wishlistElm.find('.tooltip').text(theme.strings.add_to_wishlist);
        };
    },

    doActionWishlish: function() {
        var iconWishLists = '[data-icon-wishlist]';
        doc.off('click.addOrRemoveWishlist', iconWishLists).on('click.addOrRemoveWishlist', iconWishLists, function(e) {
            e.preventDefault();
            var self = $(this),
                productId = self.data('id'),
                ProductHandle = self.data('product-handle'),
                idxArr = arrWishLists.indexOf(ProductHandle);

            if (!self.hasClass('whislist-added')) {
                self.addClass('whislist-added');
                self.find('.tooltip').text(theme.strings.remove_wishlist);

                if ($('[data-wishlist-container]').length) {
                    univer.wishListTempItem(ProductHandle);
                };

                arrWishLists.push(ProductHandle);
                localStorage.setItem('items', JSON.stringify(arrWishLists));
            } else {
                self.removeClass('whislist-added');
                self.find('.tooltip').text(theme.strings.add_to_wishlist);

                if ($('[data-wishlist-added="wishlist-' + productId + '"]').length) {
                    $('[data-wishlist-added="wishlist-' + productId + '"]').remove();
                }
                arrWishLists.splice(idxArr, 1);
                localStorage.setItem('items', JSON.stringify(arrWishLists));
            };
            univer.addedWishlist(ProductHandle);
        });
    },

    wishListIcons: function() {
        var wishListItems = localStorage.getItem('items') ? JSON.parse(localStorage.getItem('items')) : [];

        if (!wishListItems.length) {
            return;
        }

        for (var i = 0; i < wishListItems.length; i++) {
            var icon = $('[data-product-handle="' + wishListItems[i] + '"]');
            icon.addClass('whislist-added');
            icon.find('.tooltip').text(theme.strings.remove_wishlist);
        };
    },

    scrollToTop: function() {
        jQuery('#btnscrollup').fadeOut();
        jQuery(window).scroll(function() {
            if (jQuery(this).scrollTop() != 0) {
                jQuery('#btnscrollup').fadeIn();
            } else {
                jQuery('#btnscrollup').fadeOut();
            }
        });
        jQuery('#btnscrollup').on('click', function() {
            jQuery('body,html').animate({ scrollTop: 0 }, 800);
        });

    },

    initColorSwatch: function() {
        var itemSwatchSlt = '.color-swatch li label';
        $('body').off('click.toggleClass').on('click.toggleClass', itemSwatchSlt, function() {
            var self = $(this),
                productItemElm = self.closest('.uni-product-loop-item'),
                sidebarWidgetProduct = productItemElm.closest('.sidebar-widget-product');

            $('.color-swatch li label').removeClass('active');
            self.addClass('active');
            var newImage = self.data('img');
            if (newImage) {
                productItemElm.find('.vk-img-frame img.img-featured').attr({
                    src: newImage,
                    "data-src": newImage
                });

                return false;
            }
        });
    },

    clickedProductTabs: function() {
        var productTabsSection = $('[data-home-product-tabs]');
        productTabsSection.each(function() {
            var self = $(this),
                listTabs = self.find('.list-product-tabs'),
                tabLink = listTabs.find('[data-product-tabTop]'),
                tabContent = self.find('[data-product-TabContent]');

            var linkActive = self.find('.list-product-tabs .tab-links.active'),
                activeTab = self.find('.product-tabs-content .tab-content.active');

            univer.doAjaxProductTabs(linkActive.data('href'), activeTab.find('.loading'), activeTab.find('.products-grid'));

            tabLink.off('click').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();

                if ($(this).hasClass('active')) {
                    return;
                }

                if (!$(this).hasClass('active')) {
                    var curTab = $(this),
                        curTabContent = $(curTab.data('target'));

                    tabLink.removeClass('active');
                    tabContent.removeClass('active');
                    if (!curTabContent.find('.products-grid').hasClass('slick-initialized')) {
                        univer.doAjaxProductTabs(curTab.data('href'), curTabContent.find('.loading'), curTabContent.find('.products-grid'));
                    }
                    curTab.addClass('active');
                    curTabContent.addClass('active');
                };
            });
        });
    },

    doAjaxProductTabs: function(handle, loadingElm, curTabContent) {
        $.ajax({
            type: "get",
            url: handle,
            beforeSend: function() {
                loadingElm.text('...');
            },
            success: function(data) {
                loadingElm.hide();
                if (handle == '/collections/?view=json') {
                    loadingElm.text('Please link to collections').show();
                } else {
                    curTabContent.html($(data).find('.grid-items').html());
                    if (!curTabContent.hasClass('slick-initialized') && curTabContent.parent().hasClass('layout_carousel')) {
                        univer.productTabsSlider(curTabContent.parent());
                    } else {
                        univer.productTabsGrid(curTabContent.parent());
                    };
                    univer.univerTimeout = setTimeout(function() {
                        if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
                            return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                        };
                    }, 1000);
                };
                jQuery(".plus-action-prod").on('click', function(e) {
                    jQuery(this).prev().toggleClass('selected');
                   
                });
                var e = e || "body",
                    t = "";
                jQuery(e).find(".quickview .quick_view").magnificPopup({
                    type: "ajax",
                    preloader: !0,
                    tLoading: "",
                    mainClass: "quickview",
                    removalDelay: 200,
                    gallery: {
                        enabled: !1
                    },
                    callbacks: {
                        open: function() {
                            0 < $("#main").next(".product-360-view-wrapper").length && $("#main").next(".product-360-view-wrapper").remove()
                        },
                        ajaxContentAdded: function() {
                            var t = new theme.Sections;
                            t.register("product-quickview-template", theme.Product), Shopify.PaymentButton.init();
                            $('.slider-for').slick({
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                fade: true,
                                asNavFor: '.slider-nav'
                            });
                            $('.slider-nav').slick({
                                slidesToShow: 4,
                                slidesToScroll: 1,
                                asNavFor: '.slider-for',
                                dots: false,
                                arrows: false,
                                focusOnSelect: true,
                                responsive: [{
                                    breakpoint: 576,
                                    settings: {
                                        verticalSwiping: false,
                                        vertical: false,
                                        arrows: false,
                                    }
                                }, ],
                            });

                        },
                        beforeClose: function() {
                            0 < $(".quickview._reopen").length && "" != $(".quickview._reopen").data("_qid") && (t = $(".quickview._reopen").data("_qid"))
                        },
                        afterClose: function() {
                            "" != t && ($(t).trigger("click"), t = "")
                        }
                    }
                });
            },

            error: function(xhr, text) {
                loadingElm.text('Sorry, there are no products in this collection').show();
            }
        });
    },
    productTabsGrid: function(slt) {
        slt.each(function() {
            var self = $(this),
                girdclass = '',
                productGrid = self.find('.products-grid'),
                gridColumns = productGrid.data('columns');
            switch (gridColumns) {
                case 2:
                    girdclass = 'col-lg-6 col-md-6';
                    break;
                case 3:
                    girdclass = 'col-lg-4 col-md-6';
                    break;
                case 4:
                    girdclass = 'col-lg-3 col-md-6';
                    break;
                default:
                    girdclass = 'col-lg-4 col-md-6';
            }
            self.find('.grid-item').addClass(girdclass);

        });
    },
    productTabsSlider: function(slt) {
        slt.each(function() {
            var self = $(this),
                productGrid = self.find('.products-grid'),
                gridItemWidth = productGrid.data('columns');

            if (productGrid.not('.slick-initialized') && productGrid.find('.uni-product-loop-item').length) {
                productGrid.slick({
                    rows: productGrid.data('row'),
                    slidesToShow: productGrid.data('columns'),
                    slidesToScroll: 1,
                    dots: true,
                    infinite: false,
                    speed: 1000,
                    nextArrow: '<button  class="next slick-arrow"><i class="uni-icomoon icon-chevron-right"></i></button>',
                    prevArrow: '<button  class="prev slick-arrow"><i class="uni-icomoon icon-chevron-left"></i></button>',
                    responsive: [{
                            breakpoint: 1200,
                            settings: {
                                dots: true,
                                arrows: false,
                                get slidesToShow() {
                                    if (self.hasClass('sections-has-banner')) {
                                        return this.slidesToShow = 2;
                                    } else {
                                        if (gridItemWidth >= 4) {
                                            return this.slidesToShow = 4;
                                        } else if (gridItemWidth = 3) {
                                            return this.slidesToShow = 3
                                        } else {
                                            return this.slidesToShow = 2
                                        }
                                    }
                                },
                                get slidesToScroll() {
                                    if (self.hasClass('sections-has-banner')) {
                                        return this.slidesToScroll = 2;
                                    } else {
                                        if (gridItemWidth >= 4) {
                                            return this.slidesToScroll = 4;
                                        } else if (gridItemWidth = 3) {
                                            return this.slidesToScroll = 3
                                        } else {
                                            return this.slidesToScroll = 2
                                        }
                                    };
                                }
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                dots: true,
                                arrows: false,
                                get slidesToShow() {
                                    if (self.hasClass('sections-has-banner')) {
                                        return this.slidesToShow = 2;
                                    } else {
                                        if (gridItemWidth >= 3) {
                                            return this.slidesToShow = 3;
                                        } else {
                                            this.slidesToShow = 2
                                        }
                                    }
                                },
                                get slidesToScroll() {
                                    if (self.hasClass('sections-has-banner')) {
                                        return this.slidesToScroll = 2;
                                    } else {
                                        if (gridItemWidth >= 3) {
                                            return this.slidesToScroll = 3;
                                        } else {
                                            return this.slidesToScroll = 2
                                        }
                                    };
                                }
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                arrows: false,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: false,
                                dots: true
                            }
                        }
                    ]
                });
            }
        });
    }
}

theme.Sections = function Sections() {
    this.constructors = {};
    this.instances = [];

    $(document)
        .on('shopify:section:load', this._onSectionLoad.bind(this))
        .on('shopify:section:unload', this._onSectionUnload.bind(this))
        .on('shopify:section:select', this._onSelect.bind(this))
        .on('shopify:section:deselect', this._onDeselect.bind(this))
        .on('shopify:block:select', this._onBlockSelect.bind(this))
        .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
    _createInstance: function(container, constructor) {
        var $container = $(container);
        var id = $container.attr('data-section-id');
        var type = $container.attr('data-section-type');

        constructor = constructor || this.constructors[type];

        if (_.isUndefined(constructor)) {
            return;
        }

        var instance = _.assignIn(new constructor(container), {
            id: id,
            type: type,
            container: container
        });

        this.instances.push(instance);
    },

    _onSectionLoad: function(evt) {
        var container = $('[data-section-id]', evt.target)[0];
        if (container) {
            this._createInstance(container);
        }
    },

    _onSectionUnload: function(evt) {
        this.instances = _.filter(this.instances, function(instance) {
            var isEventInstance = instance.id === evt.detail.sectionId;

            if (isEventInstance) {
                if (_.isFunction(instance.onUnload)) {
                    instance.onUnload(evt);
                }
            }

            return !isEventInstance;
        });
    },

    _onSelect: function(evt) {
        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
            instance.onSelect(evt);
        }
    },

    _onDeselect: function(evt) {
        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
            instance.onDeselect(evt);
        }
    },

    _onBlockSelect: function(evt) {

        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
            instance.onBlockSelect(evt);
        }
    },

    _onBlockDeselect: function(evt) {

        var instance = _.find(this.instances, function(instance) {
            return instance.id === evt.detail.sectionId;
        });

        if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
            instance.onBlockDeselect(evt);
        }
    },

    register: function(type, constructor) {
        this.constructors[type] = constructor;

        $('[data-section-type=' + type + ']').each(
            function(index, container) {
                this._createInstance(container, constructor);
            }.bind(this)
        );
    }
});

window.slate = window.slate || {};

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {    
    getParameterByName: function(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    keyboardKeys: {
        TAB: 9,
        ENTER: 13,
        ESCAPE: 27,
        LEFTARROW: 37,
        RIGHTARROW: 39
    }
};

window.slate = window.slate || {};

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
    wrapTable: function(options) {
        options.$tables.wrap(
            '<div class="' + options.tableWrapperClass + '"></div>'
        );
    },    
    wrapIframe: function(options) {
        options.$iframes.each(function() {

            $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>');


            this.src = this.src;
        });
    }
};

window.slate = window.slate || {};

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
    /**
     * For use when focus shifts to a container rather than a link
     * eg for In-page links, after scroll, focus shifts to content area so that
     * next `tab` is where user expects if focusing a link, just $link.focus();
     *
     * @param {JQuery} $element - The element to be acted upon
     */
    pageLinkFocus: function($element) {
        var focusClass = 'js-focus-hidden';

        $element
            .first()
            .attr('tabIndex', '-1')
            .focus()
            .addClass(focusClass)
            .one('blur', callback);

        function callback() {
            $element
                .first()
                .removeClass(focusClass)
                .removeAttr('tabindex');
        }
    },

    /**
     * If there's a hash in the url, focus the appropriate element
     */
    focusHash: function() {
        var hash = window.location.hash;        
        if (hash && document.getElementById(hash.slice(1))) {
            this.pageLinkFocus($(hash));
        }
    },

    /**
     * When an in-page (url w/hash) link is clicked, focus the appropriate element
     */
    bindInPageLinks: function() {
        $('a[href*=#]').on(
            'click',
            function(evt) {
                this.pageLinkFocus($(evt.currentTarget.hash));
            }.bind(this)
        );
    },
    
    trapFocus: function(options) {
        var eventsName = {
            focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
            focusout: options.namespace ?
                'focusout.' + options.namespace : 'focusout',
            keydown: options.namespace ?
                'keydown.' + options.namespace : 'keydown.handleFocus'
        };
        var $focusableElements = options.$container.find(
            $(
                'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
            ).filter(':visible')
        );
        var firstFocusable = $focusableElements[0];
        var lastFocusable = $focusableElements[$focusableElements.length - 1];

        if (!options.$elementToFocus) {
            options.$elementToFocus = options.$container;
        }

        function _manageFocus(evt) {
            if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return;
            if (evt.target === lastFocusable && !evt.shiftKey) {
                evt.preventDefault();
                firstFocusable.focus();
            }            
            if (evt.target === firstFocusable && evt.shiftKey) {
                evt.preventDefault();
                lastFocusable.focus();
            }
        }

        options.$container.attr('tabindex', '-1');
        options.$elementToFocus.focus();

        $(document).off('focusin');

        $(document).on(eventsName.focusout, function() {
            $(document).off(eventsName.keydown);
        });

        $(document).on(eventsName.focusin, function(evt) {
            if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

            $(document).on(eventsName.keydown, function(evt) {
                _manageFocus(evt);
            });
        });
    },
    removeTrapFocus: function(options) {
        var eventName = options.namespace ?
            'focusin.' + options.namespace :
            'focusin';

        if (options.$container && options.$container.length) {
            options.$container.removeAttr('tabindex');
        }

        $(document).off(eventName);
    },
    accessibleLinks: function(options) {
        var body = document.querySelector('body');

        var idSelectors = {
            newWindow: 'a11y-new-window-message',
            external: 'a11y-external-message',
            newWindowExternal: 'a11y-new-window-external-message'
        };

        if (options.$links === undefined || !options.$links.jquery) {
            options.$links = $('a[href]:not([aria-describedby])');
        }

        function generateHTML(customMessages) {
            if (typeof customMessages !== 'object') {
                customMessages = {};
            }

            var messages = $.extend({
                    newWindow: 'Opens in a new window.',
                    external: 'Opens external website.',
                    newWindowExternal: 'Opens external website in a new window.'
                },
                customMessages
            );

            var container = document.createElement('ul');
            var htmlMessages = '';

            for (var message in messages) {
                htmlMessages +=
                    '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>';
            }

            container.setAttribute('hidden', true);
            container.innerHTML = htmlMessages;
            body.appendChild(container);
        }

        function _externalSite($link) {
            var hostname = window.location.hostname;
            return $link[0].hostname !== hostname;
        }

        $.each(options.$links, function() {
            var $link = $(this);
            var target = $link.attr('target');
            var rel = $link.attr('rel');
            var isExternal = _externalSite($link);
            var isTargetBlank = target === '_blank';

            if (isExternal) {
                $link.attr('aria-describedby', idSelectors.external);
            }
            if (isTargetBlank) {
                if (rel === undefined || rel.indexOf('noopener') === -1) {
                    $link.attr('rel', function(i, val) {
                        var relValue = val === undefined ? '' : val + ' ';
                        return relValue + 'noopener';
                    });
                }
                $link.attr('aria-describedby', idSelectors.newWindow);
            }
            if (isExternal && isTargetBlank) {
                $link.attr('aria-describedby', idSelectors.newWindowExternal);
            }
        });

        generateHTML(options.messages);
    }
};

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {
    function preload(images, size) {
        if (typeof images === 'string') {
            images = [images];
        }

        for (var i = 0; i < images.length; i++) {
            var image = images[i];
            this.loadImage(this.getSizedImageUrl(image, size));
        }
    }

    function loadImage(path) {
        new Image().src = path;
    }
    function switchImage(image, element, callback) {
        var size = this.imageSize(element.src);
        var imageUrl = this.getSizedImageUrl(image.src, size);

        if (callback) {
            callback(imageUrl, image, element);
        } else {
            element.src = imageUrl;
        }
    }

    function imageSize(src) {
        var match = src.match(
            /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
        );

        if (match !== null) {
            if (match[2] !== undefined) {
                return match[1] + match[2];
            } else {
                return match[1];
            }
        } else {
            return null;
        }
    }

    function getSizedImageUrl(src, size) {
        if (size === null) {
            return src;
        }

        if (size === 'master') {
            return this.removeProtocol(src);
        }

        var match = src.match(
            /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
        );

        if (match !== null) {
            var prefix = src.split(match[0]);
            var suffix = match[0];

            return this.removeProtocol(prefix[0] + '_' + size + suffix);
        }

        return null;
    }

    function removeProtocol(path) {
        return path.replace(/http(s)?:/, '');
    }

    return {
        preload: preload,
        loadImage: loadImage,
        switchImage: switchImage,
        imageSize: imageSize,
        getSizedImageUrl: getSizedImageUrl,
        removeProtocol: removeProtocol
    };
})();

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
    var moneyFormat = '${{amount}}'; // eslint-disable-line camelcase

    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
            cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
            thousands = thousands || ',';
            decimal = decimal || '.';

            if (isNaN(number) || number === null) {
                return 0;
            }

            number = (number / 100.0).toFixed(precision);

            var parts = number.split('.');
            var dollarsAmount = parts[0].replace(
                /(\d)(?=(\d\d\d)+(?!\d))/g,
                '$1' + thousands
            );
            var centsAmount = parts[1] ? decimal + parts[1] : '';

            return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break;
            case 'amount_no_decimals_with_space_separator':
                value = formatWithDelimiters(cents, 0, ' ');
                break;
            case 'amount_with_apostrophe_separator':
                value = formatWithDelimiters(cents, 2, "'");
                break;
        }

        return formatString.replace(placeholderRegex, value);
    }

    return {
        formatMoney: formatMoney
    };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {
    function Variants(options) {
        this.$container = options.$container;
        this.product = options.product;
        this.singleOptionSelector = options.singleOptionSelector;
        this.originalSelectorId = options.originalSelectorId;
        this.enableHistoryState = options.enableHistoryState;
        this.currentVariant = this._getVariantFromOptions();

        $(this.singleOptionSelector, this.$container).on(
            'change',
            this._onSelectChange.bind(this)
        );
    }

    Variants.prototype = _.assignIn({}, Variants.prototype, {
    
        _getCurrentOptions: function() {
            var currentOptions = _.map(
                $(this.singleOptionSelector, this.$container),
                function(element) {
                    var $element = $(element);
                    var type = $element.attr('type');
                    var currentOption = {};

                    if (type === 'radio' || type === 'checkbox') {
                        if ($element[0].checked) {
                            currentOption.value = $element.val();
                            currentOption.index = $element.data('index');

                            return currentOption;
                        } else {
                            return false;
                        }
                    } else {
                        currentOption.value = $element.val();
                        currentOption.index = $element.data('index');

                        return currentOption;
                    }
                }
            );            
            currentOptions = _.compact(currentOptions);

            return currentOptions;
        },
        _getVariantFromOptions: function() {
            var selectedValues = this._getCurrentOptions();
            var variants = this.product.variants;

            var found = _.find(variants, function(variant) {
                return selectedValues.every(function(values) {
                    return _.isEqual(variant[values.index], values.value);
                });
            });

            return found;
        },
        _onSelectChange: function() {
            var variant = this._getVariantFromOptions();

            this.$container.trigger({
                type: 'variantChange',
                variant: variant
            });

            if (!variant) {
                return;
            }

            this._updateMasterSelect(variant);
            this._updateImages(variant);
            this._updatePrice(variant);
            this._updateSKU(variant);
            this.currentVariant = variant;

sezzleInstall(variant);

            if (this.enableHistoryState) {
                this._updateHistoryState(variant);
            }
        },

        _updateImages: function(variant) {
            var variantImage = variant.featured_image || {};
            var currentVariantImage = this.currentVariant.featured_image || {};

            if (
                !variant.featured_image ||
                variantImage.src === currentVariantImage.src
            ) {
                return;
            }

            this.$container.trigger({
                type: 'variantImageChange',
                variant: variant
            });
        },

        _updatePrice: function(variant) {
            if (
                variant.price === this.currentVariant.price &&
                variant.compare_at_price === this.currentVariant.compare_at_price
            ) {
                return;
            }

            this.$container.trigger({
                type: 'variantPriceChange',
                variant: variant
            });
        },        
        _updateSKU: function(variant) {
            if (variant.sku === this.currentVariant.sku) {
                return;
            }

            this.$container.trigger({
                type: 'variantSKUChange',
                variant: variant
            });
        },

        _updateHistoryState: function(variant) {
            if (!history.replaceState || !variant) {
                return;
            }

            var newurl =
                window.location.protocol +
                '//' +
                window.location.host +
                window.location.pathname +
                '?variant=' +
                variant.id;
            window.history.replaceState({ path: newurl }, '', newurl);
        },

        _updateMasterSelect: function(variant) {
            $(this.originalSelectorId, this.$container).val(variant.id);
        }
    });

    return Variants;
})();



/* ================ MODULES ================ */

window.theme = window.theme || {};

(function() {
    var selectors = {
        backButton: '.return-link'
    };

    var $backButton = $(selectors.backButton);

    if (!document.referrer || !$backButton.length || !window.history.length) {
        return;
    }

    $backButton.one('click', function(evt) {
        evt.preventDefault();

        var referrerDomain = urlDomain(document.referrer);
        var shopDomain = urlDomain(window.location.href);

        if (shopDomain === referrerDomain) {
            history.back();
        }

        return false;
    });

    function urlDomain(url) {
        var anchor = document.createElement('a');
        anchor.ref = url;

        return anchor.hostname;
    }
})();

theme.Slideshow = (function() {
    this.$slideshow = null;
    var classes = {
        slideshow: 'slideshow',
        slickActiveMobile: 'slick-active-mobile',
        controlsHover: 'slideshow__controls--hover',
        isPaused: 'is-paused'
    };

    var selectors = {
        section: '.shopify-section',
        wrapper: '#SlideshowWrapper-',
        slides: '.slideshow__slide',
        textWrapperMobile: '.slideshow__text-wrap--mobile',
        textContentMobile: '.slideshow__text-content--mobile',
        controls: '.slideshow__controls',
        pauseButton: '.slideshow__pause',
        dots: '.slick-dots',
        arrows: '.slideshow__arrows',
        arrowsMobile: '.slideshow__arrows--mobile',
        arrowLeft: '.slideshow__arrow-left',
        arrowRight: '.slideshow__arrow-right'
    };

    function slideshow(el, sectionId) {
        var $slideshow = (this.$slideshow = $(el));
        this.adaptHeight = this.$slideshow.data('adapt-height');
        this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId);
        this.$section = this.$wrapper.closest(selectors.section);
        this.$controls = this.$wrapper.find(selectors.controls);
        this.$arrows = this.$section.find(selectors.arrows);
        this.$arrowsMobile = this.$section.find(selectors.arrowsMobile);
        this.$pause = this.$controls.find(selectors.pauseButton);
        this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile);
        this.autorotate = this.$slideshow.data('autorotate');
        var autoplaySpeed = this.$slideshow.data('speed');
        var loadSlideA11yString = this.$slideshow.data('slide-nav-a11y');
        var loadSlideNumb = this.$slideshow.data('slide-nav-number');        

        this.settings = {
            accessibility: true,
            arrows: false,
            dots: true,
            fade: true,
            draggable: true,
            touchThreshold: 20,
            autoplay: this.autorotate,
            autoplaySpeed: autoplaySpeed,            
            appendDots: this.$arrows,
            customPaging: function(slick, index) {
                return (
                    '<a href="' +
                    selectors.wrapper +
                    sectionId +
                    '" aria-label="' +
                    loadSlideA11yString.replace('[slide_number]', index + 1) +
                    '" data-slide-number="' +
                    index +
                    '">'+ loadSlideNumb.replace('[slide_number]', index + 1) +'</a>'
                );
            }
        };

        this.$slideshow.on('beforeChange', beforeChange.bind(this));
        this.$slideshow.on('init', slideshowA11ySetup.bind(this));
        this.$slideshow.on(
            'init',
            function() {
                this.$mobileDots
                    .find('li:first-of-type')
                    .addClass(classes.slickActiveMobile);
                this.showMobileText(0);
            }.bind(this)
        );

        if (this.adaptHeight) {
            this.setSlideshowHeight();
            $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)));
        }

        this.$slideshow.slick(this.settings);
        slideshowPostInitA11ySetup.bind(this)();

        this.$arrows.find(selectors.arrowLeft).on('click', function() {
            $slideshow.slick('slickPrev');
        });
        this.$arrows.find(selectors.arrowRight).on('click', function() {
            $slideshow.slick('slickNext');
        });

        this.$pause.on('click', this.togglePause.bind(this));
    }

    function slideshowA11ySetup(event, obj) {
        var $slider = obj.$slider;
        var $list = obj.$list;
        this.$dots = this.$section.find(selectors.dots);
        this.$mobileDots = this.$dots.eq(1);
        $list.removeAttr('aria-live');
        this.$wrapper.on('keyup', keyboardNavigation.bind(this));
        this.$controls.on('keyup', keyboardNavigation.bind(this));
        this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this));
        this.$wrapper
            .on(
                'focusin',
                function(evt) {
                    if (!this.$wrapper.has(evt.target).length) {
                        return;
                    }

                    $list.attr('aria-live', 'polite');
                    if (this.autorotate) {
                        $slider.slick('slickPause');
                    }
                }.bind(this)
            )
            .on(
                'focusout',
                function(evt) {
                    if (!this.$wrapper.has(evt.target).length) {
                        return;
                    }

                    $list.removeAttr('aria-live');
                    if (this.autorotate) {
                        if (!this.$pause.is('.is-paused')) {
                            $slider.slick('slickPlay');
                        }
                    }
                }.bind(this)
            );

        if (this.$dots) {
            this.$dots
                .find('a')
                .each(function() {
                    var $dot = $(this);
                    $dot.on('click keyup', function(evt) {
                        if (
                            evt.type === 'keyup' &&
                            evt.which !== slate.utils.keyboardKeys.ENTER
                        )
                            return;
                        evt.preventDefault();
                        var slideNumber = $(evt.target).data('slide-number');
                        $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber);
                        if (evt.type === 'keyup') {
                            $slider.focus();
                        }
                    });
                })
                .eq(0)
                .attr('aria-current', 'true');
        }

        this.$controls
            .on('focusin', highlightControls.bind(this))
            .on('focusout', unhighlightControls.bind(this));
    }

    function slideshowPostInitA11ySetup() {
        var $slides = this.$slideshow.find(selectors.slides);

        $slides.removeAttr('role').removeAttr('aria-labelledby');
        this.$dots
            .removeAttr('role')
            .find('li')
            .removeAttr('role')
            .removeAttr('aria-selected')
            .each(function() {
                var $dot = $(this);
                var ariaControls = $dot.attr('aria-controls');
                $dot
                    .removeAttr('aria-controls')
                    .find('a')
                    .attr('aria-controls', ariaControls);
            });
    }

    function beforeChange(event, slick, currentSlide, nextSlide) {
        var $dotLinks = this.$dots.find('a');
        var $mobileDotLinks = this.$mobileDots.find('li');

        $dotLinks
            .removeAttr('aria-current')
            .eq(nextSlide)
            .attr('aria-current', 'true');

        $mobileDotLinks
            .removeClass(classes.slickActiveMobile)
            .eq(nextSlide)
            .addClass(classes.slickActiveMobile);
        this.showMobileText(nextSlide);
    }

    function keyboardNavigation() {
        if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
            this.$slideshow.slick('slickPrev');
        }
        if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
            this.$slideshow.slick('slickNext');
        }
    }

    function highlightControls() {
        this.$controls.addClass(classes.controlsHover);
    }

    function unhighlightControls() {
        this.$controls.removeClass(classes.controlsHover);
    }

    slideshow.prototype.togglePause = function() {
        var slideshowSelector = getSlideshowId(this.$pause);
        if (this.$pause.hasClass(classes.isPaused)) {
            this.$pause.removeClass(classes.isPaused).attr('aria-pressed', 'false');
            if (this.autorotate) {
                $(slideshowSelector).slick('slickPlay');
            }
        } else {
            this.$pause.addClass(classes.isPaused).attr('aria-pressed', 'true');
            if (this.autorotate) {
                $(slideshowSelector).slick('slickPause');
            }
        }
    };

    slideshow.prototype.setSlideshowHeight = function() {
        var minAspectRatio = this.$slideshow.data('min-aspect-ratio');
        this.$slideshow.height($(document).width() / minAspectRatio);
    };

    slideshow.prototype.showMobileText = function(slideIndex) {
        var $allTextContent = this.$textWrapperMobile.find(
            selectors.textContentMobile
        );
        var currentTextContentSelector =
            selectors.textContentMobile + '-' + slideIndex;
        var $currentTextContent = this.$textWrapperMobile.find(
            currentTextContentSelector
        );
        if (
            !$currentTextContent.length &&
            this.$slideshow.find(selectors.slides).length === 1
        ) {
            this.$textWrapperMobile.hide();
        } else {
            this.$textWrapperMobile.show();
        }
        $allTextContent.hide();
        $currentTextContent.show();
    };

    function getSlideshowId($el) {
        return '#Slideshow-' + $el.data('id');
    }

    return slideshow;
})();

window.theme = window.theme || {};

theme.Hero = (function() {
    var classes = {
        indexSectionFlush: 'index-section--flush'
    };

    var selectors = {
        heroFixedWidthContent: '.hero-fixed-width__content',
        heroFixedWidthImage: '.hero-fixed-width__image'
    };

    function hero(el, sectionId) {
        this.$hero = $(el);
        this.layout = this.$hero.data('layout');
        var $parentSection = $('#shopify-section-' + sectionId);
        var $heroContent = $parentSection.find(selectors.heroFixedWidthContent);
        var $heroImage = $parentSection.find(selectors.heroFixedWidthImage);

        if (this.layout !== 'fixed_width') {
            return;
        }

        $parentSection.removeClass(classes.indexSectionFlush);
        heroFixedHeight();
        $(window).resize(
            $.debounce(50, function() {
                heroFixedHeight();
            })
        );

        function heroFixedHeight() {
            var contentHeight = $heroContent.height() + 50;
            var imageHeight = $heroImage.height();
            if (contentHeight > imageHeight) {
                $heroImage.css('min-height', contentHeight);
            }
        }
    }

    return hero;
})();


/* ================ TEMPLATES ================ */
(function() {
    var $filterBy = $('#BlogTagFilter');

    if (!$filterBy.length) {
        return;
    }

    $filterBy.on('change', function() {
        location.href = $(this).val();
    });
})();

/*================ SECTIONS ================*/
window.theme = window.theme || {};

theme.Cart = (function() {
    var selectors = {
        cartCount: '[data-cart-count]',
        cartCountBubble: '[data-cart-count-bubble]',
        cartDiscount: '[data-cart-discount]',
        cartDiscountTitle: '[data-cart-discount-title]',
        cartDiscountAmount: '[data-cart-discount-amount]',
        cartDiscountWrapper: '[data-cart-discount-wrapper]',
        cartErrorMessage: '[data-cart-error-message]',
        cartErrorMessageWrapper: '[data-cart-error-message-wrapper]',
        cartItem: '[data-cart-item]',
        cartItemDetails: '[data-cart-item-details]',
        cartItemDiscount: '[data-cart-item-discount]',
        cartItemDiscountedPriceGroup: '[data-cart-item-discounted-price-group]',
        cartItemDiscountTitle: '[data-cart-item-discount-title]',
        cartItemDiscountAmount: '[data-cart-item-discount-amount]',
        cartItemDiscountList: '[data-cart-item-discount-list]',
        cartItemFinalPrice: '[data-cart-item-final-price]',
        cartItemImage: '[data-cart-item-image]',
        cartItemLinePrice: '[data-cart-item-line-price]',
        cartItemOriginalPrice: '[data-cart-item-original-price]',
        cartItemPrice: '[data-cart-item-price]',
        cartItemPriceList: '[data-cart-item-price-list]',
        cartItemProperty: '[data-cart-item-property]',
        cartItemPropertyName: '[data-cart-item-property-name]',
        cartItemPropertyValue: '[data-cart-item-property-value]',
        cartItemRegularPriceGroup: '[data-cart-item-regular-price-group]',
        cartItemRegularPrice: '[data-cart-item-regular-price]',
        cartItemTitle: '[data-cart-item-title]',
        cartItemOption: '[data-cart-item-option]',
        cartLineItems: '[data-cart-line-items]',
        cartNote: '[data-cart-notes]',
        cartQuantityErrorMessage: '[data-cart-quantity-error-message]',
        cartQuantityErrorMessageWrapper: '[data-cart-quantity-error-message-wrapper]',
        cartRemove: '[data-cart-remove]',
        cartStatus: '[data-cart-status]',
        cartSubtotal: '[data-cart-subtotal]',
        cartTableCell: '[data-cart-table-cell]',
        cartWrapper: '[data-cart-wrapper]',
        emptyPageContent: '[data-empty-page-content]',
        quantityInput: '[data-quantity-input]',
        quantityInputMobile: '[data-quantity-input-mobile]',
        quantityInputDesktop: '[data-quantity-input-desktop]',
        quantityLabelMobile: '[data-quantity-label-mobile]',
        quantityLabelDesktop: '[data-quantity-label-desktop]',
        inputQty: '[data-quantity-input]',
        thumbnails: '.cart__image',
        unitPrice: '[data-unit-price]',
        unitPriceBaseUnit: '[data-unit-price-base-unit]',
        unitPriceGroup: '[data-unit-price-group]'
    };

    var classes = {
        cartNoCookies: 'cart--no-cookies',
        cartRemovedProduct: 'cart__removed-product',
        hide: 'hide',
        inputError: 'input--error'
    };

    var attributes = {
        cartItemIndex: 'data-cart-item-index',
        cartItemKey: 'data-cart-item-key',
        cartItemQuantity: 'data-cart-item-quantity',
        cartItemTitle: 'data-cart-item-title',
        cartItemUrl: 'data-cart-item-url',
        quantityItem: 'data-quantity-item'
    };

    theme.breakpoints = theme.breakpoints || {};

    if (
        isNaN(theme.breakpoints.medium) ||
        theme.breakpoints.medium === undefined
    ) {
        theme.breakpoints.medium = 750;
    }

    var mediumUpQuery = '(min-width: ' + theme.breakpoints.medium + 'px)';

    function Cart(container) {
        this.$container = $(container);
        this.$thumbnails = $(selectors.thumbnails, this.$container);
        this.ajaxEnabled = this.$container.data('ajax-enabled');

        if (!this.cookiesEnabled()) {
            this.$container.addClass(classes.cartNoCookies);
        }

        this.$thumbnails.css('cursor', 'pointer');
        this.$container.on(
            'click',
            selectors.thumbnails,
            this._handleThumbnailClick
        );

        this.$container.on(
            'change',
            selectors.inputQty,
            $.debounce(500, this._handleInputQty.bind(this))
        );

        this.mql = window.matchMedia(mediumUpQuery);
        this.mql.addListener(this.setQuantityFormControllers.bind(this));
        this.setQuantityFormControllers();

        if (this.ajaxEnabled) {           

            this.$container.on(
                'change',
                selectors.cartNote,
                this._onNoteChange.bind(this)
            );

            this.$container.on(
                'click',
                selectors.cartRemove,
                this._onRemoveItem.bind(this)
            );

            this._setupCartTemplates();
        }
    }

    Cart.prototype = _.assignIn({}, Cart.prototype, {
        _setupCartTemplates: function() {
            this.$itemTemplate = $(selectors.cartItem, this.$container)
                .first()
                .clone();
            this.$itemDiscountTemplate = $(
                selectors.cartItemDiscount,
                this.$itemTemplate
            ).clone();
            this.$itemOptionTemplate = $(
                selectors.cartItemOption,
                this.$itemTemplate
            ).clone();
            this.$itemPropertyTemplate = $(
                selectors.cartItemProperty,
                this.$itemTemplate
            ).clone();
            this.$itemPriceListTemplate = $(
                selectors.cartItemPriceList,
                this.$itemTemplate
            ).clone();
            this.$itemLinePriceTemplate = $(
                selectors.cartItemLinePrice,
                this.$itemTemplate
            ).clone();
            this.$cartDiscountTemplate = $(
                selectors.cartDiscount,
                this.$container
            ).clone();
        },

        _handleInputQty: function(evt) {
            var $input = $(evt.target);
            var itemIndex = $input.data('quantity-item');
            var $itemElement = $input.closest(selectors.cartItem);
            var $itemQtyInputs = $('[data-quantity-item=' + itemIndex + ']');
            var value = parseInt($input.val());
            var isValidValue = !(value < 0 || isNaN(value));
            $itemQtyInputs.val(value);

            this._hideCartError();
            this._hideQuantityErrorMessage();

            if (!isValidValue) {
                this._showQuantityErrorMessages($itemElement);
                return;
            }

            if (isValidValue && this.ajaxEnabled) {
                this._updateItemQuantity(
                    itemIndex,
                    $itemElement,
                    $itemQtyInputs,
                    value
                );
            }
        },

        _updateItemQuantity: function(
            itemIndex,
            $itemElement,
            $itemQtyInputs,
            value
        ) {
            var key = $itemElement.attr(attributes.cartItemKey);
            var index = $itemElement.attr(attributes.cartItemIndex);

            var params = {
                url: '/cart/change.js',
                data: { quantity: value, line: index },
                dataType: 'json'
            };

            $.post(params)
                .done(
                    function(state) {
                        if (state.item_count === 0) {
                            this._emptyCart();
                        } else {
                            this._createCart(state);

                            if (value === 0) {
                                this._showRemoveMessage($itemElement.clone());
                            } else {
                                var $lineItem = $('[data-cart-item-key="' + key + '"]');
                                var item = this.getItem(key, state);

                                $(selectors.quantityInput, $lineItem).focus();
                                this._updateLiveRegion(item);
                            }
                        }

                        this._setCartCountBubble(state.item_count);
                    }.bind(this)
                )
                .fail(
                    function() {
                        this._showCartError($itemQtyInputs);
                    }.bind(this)
                );
        },

        getItem: function(key, state) {
            return state.items.find(function(item) {
                return item.key === key;
            });
        },

        _liveRegionText: function(item) {            
            var liveRegionText =
                theme.strings.update +
                ': [QuantityLabel]: [Quantity], [Regular] [$$] [DiscountedPrice] [$]. [PriceInformation]';
            
            liveRegionText = liveRegionText
                .replace('[QuantityLabel]', theme.strings.quantity)
                .replace('[Quantity]', item.quantity);
            
            var regularLabel = '';
            var regularPrice = theme.Currency.formatMoney(
                item.original_line_price,
                theme.moneyFormat
            );
            var discountLabel = '';
            var discountPrice = '';
            var discountInformation = '';

            if (item.original_line_price > item.final_line_price) {
                regularLabel = theme.strings.regularTotal;

                discountLabel = theme.strings.discountedTotal;
                discountPrice = theme.Currency.formatMoney(
                    item.final_line_price,
                    theme.moneyFormat
                );

                discountInformation = theme.strings.priceColumn;
            }

            liveRegionText = liveRegionText
                .replace('[Regular]', regularLabel)
                .replace('[$$]', regularPrice)
                .replace('[DiscountedPrice]', discountLabel)
                .replace('[$]', discountPrice)
                .replace('[PriceInformation]', discountInformation)
                .trim();

            return liveRegionText;
        },

        _updateLiveRegion: function(item) {
            var $liveRegion = $(selectors.cartStatus);
            $liveRegion.html(this._liveRegionText(item)).attr('aria-hidden', false);            
            setTimeout(function() {
                $liveRegion.attr('aria-hidden', true);
            }, 1000);
        },

        _createCart: function(state) {
            var cartDiscountList = this._createCartDiscountList(state);

            $(selectors.cartLineItems, this.$container).html(
                this._createLineItemList(state)
            );

            this.setQuantityFormControllers();

            $(selectors.cartNote, this.$container).val(state.note);

            if (cartDiscountList.length === 0) {
                $(selectors.cartDiscountWrapper, this.$container)
                    .html('')
                    .addClass(classes.hide);
            } else {
                $(selectors.cartDiscountWrapper, this.$container)
                    .html(cartDiscountList)
                    .removeClass(classes.hide);
            }

            $(selectors.cartSubtotal, this.$container).html(
                theme.Currency.formatMoney(
                    state.total_price,
                    theme.moneyFormatWithCurrency
                )
            );
        },

        _createCartDiscountList: function(cart) {
            return $.map(
                cart.cart_level_discount_applications,
                function(discount) {
                    var $discount = this.$cartDiscountTemplate.clone();
                    $discount.find(selectors.cartDiscountTitle).text(discount.title);
                    $discount
                        .find(selectors.cartDiscountAmount)
                        .html(
                            theme.Currency.formatMoney(
                                discount.total_allocated_amount,
                                theme.moneyFormat
                            )
                        );
                    return $discount[0];
                }.bind(this)
            );
        },

        _createLineItemList: function(state) {
            return $.map(
                state.items,
                function(item, index) {
                    var $item = this.$itemTemplate.clone();
                    var $itemPriceList = this.$itemPriceListTemplate.clone();

                    this._setLineItemAttributes($item, item, index);
                    this._setLineItemImage($item, item.featured_image);

                    $(selectors.cartItemTitle, $item)
                        .text(item.product_title)
                        .attr('href', item.url);

                    var productDetailsList = this._createProductDetailsList(
                        item.product_has_only_default_variant,
                        item.options_with_values,
                        item.properties
                    );
                    this._setProductDetailsList($item, productDetailsList);

                    this._setItemRemove($item, item.title);

                    $itemPriceList.html(
                        this._createItemPrice(
                            item.original_price,
                            item.final_price,
                            this.$itemPriceListTemplate
                        )
                    );

                    if (item.unit_price_measurement) {
                        $itemPriceList.append(
                            this._createUnitPrice(
                                item.unit_price,
                                item.unit_price_measurement,
                                this.$itemPriceListTemplate
                            )
                        );
                    }

                    this._setItemPrice($item, $itemPriceList);

                    var itemDiscountList = this._createItemDiscountList(item);
                    this._setItemDiscountList($item, itemDiscountList);

                    this._setQuantityInputs($item, item, index);

                    var itemLinePrice = this._createItemPrice(
                        item.original_line_price,
                        item.final_line_price,
                        this.$itemLinePriceTemplate
                    );
                    this._setItemLinePrice($item, itemLinePrice);

                    return $item[0];
                }.bind(this)
            );
        },

        _setLineItemAttributes: function($item, item, index) {
            $item
                .attr(attributes.cartItemKey, item.key)
                .attr(attributes.cartItemUrl, item.url)
                .attr(attributes.cartItemTitle, item.title)
                .attr(attributes.cartItemIndex, index + 1)
                .attr(attributes.cartItemQuantity, item.quantity);
        },

        _setLineItemImage: function($item, featuredImage) {
            var $image = $(selectors.cartItemImage, $item);

            var sizedImageUrl =
                featuredImage.url !== null ?
                theme.Images.getSizedImageUrl(featuredImage.url, 'x190') :
                null;

            if (sizedImageUrl) {
                $image
                    .attr('alt', featuredImage.alt)
                    .attr('src', sizedImageUrl)
                    .removeClass(classes.hide);
            } else {
                $image.remove();
            }
        },

        _setProductDetailsList: function($item, productDetailsList) {
            var $itemDetails = $(selectors.cartItemDetails, $item);

            if (productDetailsList.length === 0) {
                $itemDetails.addClass(classes.hide).text('');
            } else {
                $itemDetails.removeClass(classes.hide).html(productDetailsList);
            }
        },

        _setItemPrice: function($item, price) {
            $(selectors.cartItemPrice, $item).html(price);
        },

        _setItemDiscountList: function($item, discountList) {
            var $itemDiscountList = $(selectors.cartItemDiscountList, $item);

            if (discountList.length === 0) {
                $itemDiscountList.html('').addClass(classes.hide);
            } else {
                $itemDiscountList.html(discountList).removeClass(classes.hide);
            }
        },

        _setItemRemove: function($item, title) {
            $(selectors.cartRemove, $item).attr(
                'aria-label',
                theme.strings.removeLabel.replace('[product]', title)
            );
        },

        _setQuantityInputs: function($item, item, index) {
            $(selectors.quantityInputMobile, $item)
                .attr('id', 'updates_' + item.key)
                .attr(attributes.quantityItem, index + 1)
                .val(item.quantity);

            $(selectors.quantityInputDesktop, $item)
                .attr('id', 'updates_large_' + item.key)
                .attr(attributes.quantityItem, index + 1)
                .val(item.quantity);

            $(selectors.quantityLabelMobile, $item).attr(
                'for',
                'updates_' + item.key
            );

            $(selectors.quantityLabelDesktop, $item).attr(
                'for',
                'updates_large_' + item.key
            );
        },

        setQuantityFormControllers: function() {
            if (this.mql.matches) {
                $(selectors.quantityInputDesktop).attr('name', 'updates[]');
                $(selectors.quantityInputMobile).removeAttr('name');
            } else {
                $(selectors.quantityInputMobile).attr('name', 'updates[]');
                $(selectors.quantityInputDesktop).removeAttr('name');
            }
        },

        _setItemLinePrice: function($item, price) {
            $(selectors.cartItemLinePrice, $item).html(price);
        },

        _createProductDetailsList: function(
            product_has_only_default_variant,
            options,
            properties
        ) {
            var optionsPropertiesHTML = [];

            if (!product_has_only_default_variant) {
                optionsPropertiesHTML = optionsPropertiesHTML.concat(
                    this._getOptionList(options)
                );
            }

            if (properties !== null && Object.keys(properties).length !== 0) {
                optionsPropertiesHTML = optionsPropertiesHTML.concat(
                    this._getPropertyList(properties)
                );
            }

            return optionsPropertiesHTML;
        },

        _getOptionList: function(options) {
            return $.map(
                options,
                function(option) {
                    var $optionElement = this.$itemOptionTemplate.clone();

                    $optionElement
                        .text(option.name + ': ' + option.value)
                        .removeClass(classes.hide);

                    return $optionElement[0];
                }.bind(this)
            );
        },

        _getPropertyList: function(properties) {
            var propertiesArray =
                properties !== null ? Object.entries(properties) : [];

            return $.map(
                propertiesArray,
                function(property) {
                    var $propertyElement = this.$itemPropertyTemplate.clone();                    
                    if (property[0].charAt(0) === '_') return;                    
                    if (property[1].length === 0) return;
                    $propertyElement
                        .find(selectors.cartItemPropertyName)
                        .text(property[0]);

                    if (property[0].indexOf('/uploads/') === -1) {
                        $propertyElement
                            .find(selectors.cartItemPropertyValue)
                            .text(': ' + property[1]);
                    } else {
                        $propertyElement
                            .find(selectors.cartItemPropertyValue)
                            .html(
                                ': <a href="' +
                                property[1] +
                                '"> ' +
                                property[1].split('/').pop() +
                                '</a>'
                            );
                    }

                    $propertyElement.removeClass(classes.hide);

                    return $propertyElement[0];
                }.bind(this)
            );
        },

        _createItemPrice: function(original_price, final_price, $priceTemplate) {
            if (original_price !== final_price) {
                var $discountedPrice = $(
                    selectors.cartItemDiscountedPriceGroup,
                    $priceTemplate
                ).clone();

                $(selectors.cartItemOriginalPrice, $discountedPrice).html(
                    theme.Currency.formatMoney(original_price, theme.moneyFormat)
                );
                $(selectors.cartItemFinalPrice, $discountedPrice).html(
                    theme.Currency.formatMoney(final_price, theme.moneyFormat)
                );
                $discountedPrice.removeClass(classes.hide);

                return $discountedPrice[0];
            } else {
                var $regularPrice = $(
                    selectors.cartItemRegularPriceGroup,
                    $priceTemplate
                ).clone();

                $(selectors.cartItemRegularPrice, $regularPrice).html(
                    theme.Currency.formatMoney(original_price, theme.moneyFormat)
                );

                $regularPrice.removeClass(classes.hide);

                return $regularPrice[0];
            }
        },

        _createUnitPrice: function(
            unitPrice,
            unitPriceMeasurement,
            $itemPriceGroup
        ) {
            var $unitPriceGroup = $(
                selectors.unitPriceGroup,
                $itemPriceGroup
            ).clone();

            var unitPriceBaseUnit =
                (unitPriceMeasurement.reference_value !== 1 ?
                    unitPriceMeasurement.reference_value :
                    '') + unitPriceMeasurement.reference_unit;

            $(selectors.unitPriceBaseUnit, $unitPriceGroup).text(unitPriceBaseUnit);
            $(selectors.unitPrice, $unitPriceGroup).html(
                theme.Currency.formatMoney(unitPrice, theme.moneyFormat)
            );

            $unitPriceGroup.removeClass(classes.hide);

            return $unitPriceGroup[0];
        },

        _createItemDiscountList: function(item) {
            return $.map(
                item.line_level_discount_allocations,
                function(discount) {
                    var $discount = this.$itemDiscountTemplate.clone();
                    $discount
                        .find(selectors.cartItemDiscountTitle)
                        .text(discount.discount_application.title);
                    $discount
                        .find(selectors.cartItemDiscountAmount)
                        .html(
                            theme.Currency.formatMoney(discount.amount, theme.moneyFormat)
                        );
                    return $discount[0];
                }.bind(this)
            );
        },

        _showQuantityErrorMessages: function(itemElement) {
            $(selectors.cartQuantityErrorMessage, itemElement).text(
                theme.strings.quantityMinimumMessage
            );

            $(selectors.cartQuantityErrorMessageWrapper, itemElement).removeClass(
                classes.hide
            );

            $(selectors.inputQty, itemElement)
                .addClass(classes.inputError)
                .focus();
        },

        _hideQuantityErrorMessage: function() {
            var $errorMessages = $(
                selectors.cartQuantityErrorMessageWrapper
            ).addClass(classes.hide);

            $(selectors.cartQuantityErrorMessage, $errorMessages).text('');

            $(selectors.inputQty, this.$container).removeClass(classes.inputError);
        },

        _handleThumbnailClick: function(evt) {
            var url = $(evt.target)
                .closest(selectors.cartItem)
                .data('cart-item-url');

            window.location.href = url;
        },

        _onNoteChange: function(evt) {
            var note = evt.currentTarget.value;
            this._hideCartError();
            this._hideQuantityErrorMessage();

            var params = {
                url: '/cart/update.js',
                data: { note: note },
                dataType: 'json'
            };

            $.post(params).fail(
                function() {
                    this._showCartError(evt.currentTarget);
                }.bind(this)
            );
        },

        _showCartError: function(elementToFocus) {
            $(selectors.cartErrorMessage).text(theme.strings.cartError);

            $(selectors.cartErrorMessageWrapper).removeClass(classes.hide);

            elementToFocus.focus();
        },

        _hideCartError: function() {
            $(selectors.cartErrorMessageWrapper).addClass(classes.hide);
            $(selectors.cartErrorMessage).text('');
        },

        _onRemoveItem: function(evt) {
            evt.preventDefault();
            var $remove = $(evt.target);
            var $lineItem = $remove.closest(selectors.cartItem);
            var index = $lineItem.attr(attributes.cartItemIndex);
            this._hideCartError();

            var params = {
                url: '/cart/change.js',
                data: { quantity: 0, line: index },
                dataType: 'json'
            };

            $.post(params)
                .done(
                    function(state) {
                        if (state.item_count === 0) {
                            this._emptyCart();
                        } else {
                            this._createCart(state);
                            this._showRemoveMessage($lineItem.clone());
                        }

                        this._setCartCountBubble(state.item_count);
                    }.bind(this)
                )
                .fail(
                    function() {
                        this._showCartError(null);
                    }.bind(this)
                );
        },

        _showRemoveMessage: function(lineItem) {
            var index = lineItem.data('cart-item-index');
            var removeMessage = this._getRemoveMessage(lineItem);
            var $lineItemAtIndex;

            if (index - 1 === 0) {
                $lineItemAtIndex = $('[data-cart-item-index="1"]', this.$container);
                $(removeMessage).insertBefore($lineItemAtIndex);
            } else {
                $lineItemAtIndex = $(
                    '[data-cart-item-index="' + (index - 1) + '"]',
                    this.$container
                );
                removeMessage.insertAfter($lineItemAtIndex);
            }
            removeMessage.focus();
        },

        _getRemoveMessage: function(lineItem) {
            var formattedMessage = this._formatRemoveMessage(lineItem);

            var $tableCell = $(selectors.cartTableCell, lineItem).clone();
            $tableCell
                .removeClass()
                .addClass(classes.cartRemovedProduct)
                .attr('colspan', '4')
                .html(formattedMessage);

            lineItem
                .attr('role', 'alert')
                .html($tableCell)
                .attr('tabindex', '-1');

            return lineItem;
        },

        _formatRemoveMessage: function(lineItem) {
            var quantity = lineItem.data('cart-item-quantity');
            var url = lineItem.attr(attributes.cartItemUrl);
            var title = lineItem.attr(attributes.cartItemTitle);

            return theme.strings.removedItemMessage
                .replace('[quantity]', quantity)
                .replace(
                    '[link]',
                    '<a ' +
                    'href="' +
                    url +
                    '" class="text-link text-link--accent">' +
                    title +
                    '</a>'
                );
        },

        _setCartCountBubble: function(quantity) {
            this.$cartCountBubble =
                this.$cartCountBubble || $(selectors.cartCountBubble);
            this.$cartCount = this.$cartCount || $(selectors.cartCount);

            if (quantity > 0) {
                this.$cartCountBubble.removeClass(classes.hide);
                this.$cartCount.html(quantity);
            } else {
                this.$cartCountBubble.addClass(classes.hide);
                this.$cartCount.html('');
            }
        },

        _emptyCart: function() {
            this.$emptyPageContent =
                this.$emptyPageContent ||
                $(selectors.emptyPageContent, this.$container);
            this.$cartWrapper =
                this.$cartWrapper || $(selectors.cartWrapper, this.$container);

            this.$emptyPageContent.removeClass(classes.hide);
            this.$cartWrapper.addClass(classes.hide);
        },

        cookiesEnabled: function() {
            var cookieEnabled = navigator.cookieEnabled;

            if (!cookieEnabled) {
                document.cookie = 'testcookie';
                cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
            }
            return cookieEnabled;
        }
    });

    return Cart;
})();

window.theme = window.theme || {};

/* eslint-disable no-new */
theme.Product = (function() {
    function Product(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        this.ajaxEnabled = $container.data('ajax-enabled');

        this.settings = {            
            mediaQueryMediumUp: 'screen and (min-width: 750px)',
            mediaQuerySmall: 'screen and (max-width: 749px)',
            bpSmall: false,
            enableHistoryState: $container.data('enable-history-state') || false,
            namespace: '.slideshow-' + sectionId,
            sectionId: sectionId,
            sliderActive: false,
            zoomEnabled: false
        };

        this.selectors = {
            addToCart: '[data-add-to-cart]',
            addToCartText: '[data-add-to-cart-text]',
            cartCount: '[data-cart-count]',
            cartCountBubble: '[data-cart-count-bubble]',
            cartPopup: '[data-cart-popup]',
            cartPopupCartQuantity: '[data-cart-popup-cart-quantity]',
            cartPopupClose: '[data-cart-popup-close]',
            cartPopupDismiss: '[data-cart-popup-dismiss]',
            cartPopupImage: '[data-cart-popup-image]',
            cartPopupImageWrapper: '[data-cart-popup-image-wrapper]',
            cartPopupImagePlaceholder: '[data-cart-popup-image-placeholder]',
            cartPopupPlaceholderSize: '[data-placeholder-size]',
            cartPopupProductDetails: '[data-cart-popup-product-details]',
            cartPopupQuantity: '[data-cart-popup-quantity]',
            cartPopupQuantityLabel: '[data-cart-popup-quantity-label]',
            cartPopupTitle: '[data-cart-popup-title]',
            cartPopupWrapper: '[data-cart-popup-wrapper]',
            loader: '[data-loader]',
            loaderStatus: '[data-loader-status]',
            quantity: '[data-quantity-input]',
            SKU: '.variant-sku',
            productStatus: '[data-product-status]',
            originalSelectorId: '#ProductSelect-' + sectionId,
            productForm: '[data-product-form]',
            errorMessage: '[data-error-message]',
            errorMessageWrapper: '[data-error-message-wrapper]',
            productImageWraps: '.product-single__photo',
            productThumbImages: '.product-single__thumbnail--' + sectionId,
            productThumbs: '.product-single__thumbnails-' + sectionId,
            productThumbListItem: '.product-single__thumbnails-item',
            productFeaturedImage: '.product-featured-img',
            productThumbsWrapper: '.thumbnails-wrapper',
            saleLabel: '.product-price__sale-label-' + sectionId,
            singleOptionSelector: '.single-option-selector-' + sectionId,
            shopifyPaymentButton: '.shopify-payment-button',
            priceContainer: '[data-price]',
            regularPrice: '[data-regular-price]',
            salePrice: '[data-sale-price]',
            unitPrice: '[data-unit-price]',
            unitPriceBaseUnit: '[data-unit-price-base-unit]',
            productPolicies: '[data-product-policies]'
        };

        this.classes = {
            cartPopupWrapperHidden: 'cart-popup-wrapper--hidden',
            hidden: 'hide',
            visibilityHidden: 'visibility-hidden',
            inputError: 'input--error',
            productOnSale: 'price--on-sale',
            productUnitAvailable: 'price--unit-available',
            productUnavailable: 'price--unavailable',
            productSoldOut: 'price--sold-out',
            cartImage: 'cart-popup-item__image',
            productFormErrorMessageWrapperHidden: 'product-form__error-message-wrapper--hidden',
            activeClass: 'active-thumb',
            variantSoldOut: 'product-form--variant-sold-out'
        };

        this.$quantityInput = $(this.selectors.quantity, $container);
        this.$errorMessageWrapper = $(
            this.selectors.errorMessageWrapper,
            $container
        );
        this.$addToCart = $(this.selectors.addToCart, $container);
        this.$addToCartText = $(this.selectors.addToCartText, this.$addToCart);
        this.$shopifyPaymentButton = $(
            this.selectors.shopifyPaymentButton,
            $container
        );
        this.$productPolicies = $(this.selectors.productPolicies, $container);
        this.$loader = $(this.selectors.loader, this.$addToCart);
        this.$loaderStatus = $(this.selectors.loaderStatus, $container);

        if (!$('#ProductJson-' + sectionId).html()) {
            return;
        }

        this.productSingleObject = JSON.parse(
            document.getElementById('ProductJson-' + sectionId).innerHTML
        );

        this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
            'js-zoom-enabled'
        );

        this._initBreakpoints();
        this._stringOverrides();
        this._initVariants();
        this._initImageSwitch();
        this._initAddToCart();
        this._setActiveThumbnail();
    }

    Product.prototype = _.assignIn({}, Product.prototype, {
        _stringOverrides: function() {
            theme.productStrings = theme.productStrings || {};
            $.extend(theme.strings, theme.productStrings);
        },

        _initBreakpoints: function() {
            var self = this;

            enquire.register(this.settings.mediaQuerySmall, {
                match: function() {                    
                    if ($(self.selectors.productThumbImages).length > 3) {
                        self._initThumbnailSlider();
                    }                    
                    if (self.settings.zoomEnabled) {
                        $(self.selectors.productImageWraps).each(function() {
                            _destroyZoom(this);
                        });
                    }

                    self.settings.bpSmall = true;
                },
                unmatch: function() {
                    if (self.settings.sliderActive) {
                        self._destroyThumbnailSlider();
                    }

                    self.settings.bpSmall = false;
                }
            });

            enquire.register(this.settings.mediaQueryMediumUp, {
                match: function() {
                    if (self.settings.zoomEnabled) {
                        $(self.selectors.productImageWraps).each(function() {
                            _enableZoom(this);
                        });
                    }
                }
            });
        },

        _initVariants: function() {
            var options = {
                $container: this.$container,
                enableHistoryState: this.$container.data('enable-history-state') || false,
                singleOptionSelector: this.selectors.singleOptionSelector,
                originalSelectorId: this.selectors.originalSelectorId,
                product: this.productSingleObject
            };

            this.variants = new slate.Variants(options);

            this.$container.on(
                'variantChange' + this.settings.namespace,
                this._updateAvailability.bind(this)
            );
            this.$container.on(
                'variantImageChange' + this.settings.namespace,
                this._updateImages.bind(this)
            );
            this.$container.on(
                'variantPriceChange' + this.settings.namespace,
                this._updatePrice.bind(this)
            );
            this.$container.on(
                'variantSKUChange' + this.settings.namespace,
                this._updateSKU.bind(this)
            );
        },

        _initImageSwitch: function() {
            if (!$(this.selectors.productThumbImages).length) {
                return;
            }

            var self = this;

            $(this.selectors.productThumbImages)
                .on('click', function(evt) {
                    evt.preventDefault();
                    var $el = $(this);

                    var imageId = $el.data('thumbnail-id');

                    self._switchImage(imageId);
                    self._setActiveThumbnail(imageId);
                })
                .on('keyup', self._handleImageFocus.bind(self));
        },

        _initAddToCart: function() {
            $(this.selectors.productForm, this.$container).on(
                'submit',
                function(evt) {
                    if (this.$addToCart.is('[aria-disabled]')) {
                        evt.preventDefault();
                        return;
                    }

                    if (!this.ajaxEnabled) return;

                    evt.preventDefault();

                    this.$previouslyFocusedElement = $(':focus');

                    var isInvalidQuantity = this.$quantityInput.val() <= 0;

                    if (isInvalidQuantity) {
                        this._showErrorMessage(theme.strings.quantityMinimumMessage);
                        return;
                    }

                    if (!isInvalidQuantity && this.ajaxEnabled) {
                        this._handleButtonLoadingState(true);
                        var $data = $(this.selectors.productForm, this.$container);
                        this._addItemToCart($data);
                        return;
                    }
                }.bind(this)
            );
        },

        _addItemToCart: function(data) {
            var params = {
                url: '/cart/add.js',
                data: $(data).serialize(),
                dataType: 'json'
            };

            $.post(params)
                .done(
                    function(item) {
                        this._hideErrorMessage();
                        this._setupCartPopup(item);
                        this._setupMiniCart(item);
                    }.bind(this)
                )
                .fail(
                    function(response) {
                        this.$previouslyFocusedElement.focus();
                        var errorMessage = response.responseJSON ?
                            response.responseJSON.description :
                            theme.strings.cartError;
                        this._showErrorMessage(errorMessage);
                        this._handleButtonLoadingState(false);
                    }.bind(this)
                );
        },

        _handleButtonLoadingState: function(isLoading) {
            if (isLoading) {
                this.$addToCart.attr('aria-disabled', true);
                this.$addToCartText.addClass(this.classes.hidden);
                this.$loader.removeClass(this.classes.hidden);
                this.$shopifyPaymentButton.attr('disabled', true);
                this.$loaderStatus.attr('aria-hidden', false);
            } else {
                this.$addToCart.removeAttr('aria-disabled');
                this.$addToCartText.removeClass(this.classes.hidden);
                this.$loader.addClass(this.classes.hidden);
                this.$shopifyPaymentButton.removeAttr('disabled');
                this.$loaderStatus.attr('aria-hidden', true);
            }
        },

        _showErrorMessage: function(errorMessage) {
            $(this.selectors.errorMessage, this.$container).html(errorMessage);

            if (this.$quantityInput.length !== 0) {
                this.$quantityInput.addClass(this.classes.inputError);
            }

            this.$errorMessageWrapper
                .removeClass(this.classes.productFormErrorMessageWrapperHidden)
                .attr('aria-hidden', true)
                .removeAttr('aria-hidden');
        },

        _hideErrorMessage: function() {
            this.$errorMessageWrapper.addClass(
                this.classes.productFormErrorMessageWrapperHidden
            );

            if (this.$quantityInput.length !== 0) {
                this.$quantityInput.removeClass(this.classes.inputError);
            }
        },
        _setupMiniCart: function(item) {
            this._updateMiniCartContent(item);
        },
        _updateMiniCartContent: function(item) {
            /*var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;

            this.$cartPopupTitle.text(item.product_title);
            this.$cartPopupQuantity.text(quantity);
            this.$cartPopupQuantityLabel.text(
                theme.strings.quantityLabel.replace('[count]', quantity)
            );

            this._setCartPopupPlaceholder(
                item.featured_image.url,
                item.featured_image.aspect_ratio
            );
            this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
            this._setCartPopupProductDetails(
                item.product_has_only_default_variant,
                item.options_with_values,
                item.properties
            );

            $.getJSON('/cart.js').then(
                function(cart) {
                    this._setCartQuantity(cart.item_count);
                    this._setCartCountBubble(cart.item_count);
                    this._showCartPopup();
                }.bind(this)
            );*/
        },
        /*_setCartQuantity: function(quantity) {
            this.$cartPopupCartQuantity =
                this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
            var ariaLabel;

            if (quantity === 1) {
                ariaLabel = theme.strings.oneCartCount;
            } else if (quantity > 1) {
                ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
            }

            this.$cartPopupCartQuantity.text(quantity).attr('aria-label', ariaLabel);
        },*/
        _setupCartPopup: function(item) {
            this.$cartPopup = this.$cartPopup || $(this.selectors.cartPopup);
            this.$cartPopupWrapper =
                this.$cartPopupWrapper || $(this.selectors.cartPopupWrapper);
            this.$cartPopupTitle =
                this.$cartPopupTitle || $(this.selectors.cartPopupTitle);
            this.$cartPopupQuantity =
                this.$cartPopupQuantity || $(this.selectors.cartPopupQuantity);
            this.$cartPopupQuantityLabel =
                this.$cartPopupQuantityLabel ||
                $(this.selectors.cartPopupQuantityLabel);
            this.$cartPopupClose =
                this.$cartPopupClose || $(this.selectors.cartPopupClose);
            this.$cartPopupDismiss =
                this.$cartPopupDismiss || $(this.selectors.cartPopupDismiss);
            this.$cartPopupImagePlaceholder =
                this.$cartPopupImagePlaceholder ||
                $(this.selectors.cartPopupImagePlaceholder);

            this._setupCartPopupEventListeners();
            this._updateCartPopupContent(item);
        },

        _updateCartPopupContent: function(item) {
            var quantity = this.$quantityInput.length ? this.$quantityInput.val() : 1;

            this.$cartPopupTitle.text(item.product_title);
            this.$cartPopupQuantity.text(quantity);
            this.$cartPopupQuantityLabel.text(
                theme.strings.quantityLabel.replace('[count]', quantity)
            );

            this._setCartPopupPlaceholder(
                item.featured_image.url,
                item.featured_image.aspect_ratio
            );
            this._setCartPopupImage(item.featured_image.url, item.featured_image.alt);
            this._setCartPopupProductDetails(
                item.product_has_only_default_variant,
                item.options_with_values,
                item.properties
            );

            $.getJSON('/cart.js').then(
                function(cart) {
                    this._setCartQuantity(cart.item_count);
                    this._setCartCountBubble(cart.item_count);
                    this._showCartPopup();
                }.bind(this)
            );
        },

        _setupCartPopupEventListeners: function() {
            this.$cartPopupWrapper.on(
                'keyup',
                function(event) {
                    if (event.keyCode === slate.utils.keyboardKeys.ESCAPE) {
                        this._hideCartPopup(event);
                    }
                }.bind(this)
            );

            this.$cartPopupClose.on('click', this._hideCartPopup.bind(this));
            this.$cartPopupDismiss.on('click', this._hideCartPopup.bind(this));
            $('body').on('click', this._onBodyClick.bind(this));
        },

        _setCartPopupPlaceholder: function(imageUrl, imageAspectRatio) {
            this.$cartPopupImageWrapper =
                this.$cartPopupImageWrapper || $(this.selectors.cartPopupImageWrapper);

            if (imageUrl === null) {
                this.$cartPopupImageWrapper.addClass(this.classes.hidden);
                return;
            }

            var $placeholder = $(this.selectors.cartPopupPlaceholderSize);
            var maxWidth = 95 * imageAspectRatio;
            var heightRatio = 100 / imageAspectRatio;

            this.$cartPopupImagePlaceholder.css('max-width', maxWidth);

            $placeholder.css('padding-top', heightRatio + '%');
        },

        _setCartPopupImage: function(imageUrl, imageAlt) {
            if (imageUrl === null) return;

            this.$cartPopupImageWrapper.removeClass(this.classes.hidden);
            var sizedImageUrl = theme.Images.getSizedImageUrl(imageUrl, '200x');
            var image = document.createElement('img');
            image.src = sizedImageUrl;
            image.alt = imageAlt;
            image.classList.add(this.classes.cartImage);
            image.dataset.cartPopupImage = '';

            image.onload = function() {
                this.$cartPopupImagePlaceholder.addClass(this.classes.hidden);
                this.$cartPopupImageWrapper.append(image);
            }.bind(this);
        },

        _setCartPopupProductDetails: function(
            product_has_only_default_variant,
            options,
            properties
        ) {
            this.$cartPopupProductDetails =
                this.$cartPopupProductDetails ||
                $(this.selectors.cartPopupProductDetails);
            var variantPropertiesHTML = '';

            if (!product_has_only_default_variant) {
                variantPropertiesHTML =
                    variantPropertiesHTML + this._getVariantOptionList(options);
            }

            if (properties !== null && Object.keys(properties).length !== 0) {
                variantPropertiesHTML =
                    variantPropertiesHTML + this._getPropertyList(properties);
            }

            if (variantPropertiesHTML.length === 0) {
                this.$cartPopupProductDetails.html('');
                this.$cartPopupProductDetails.attr('hidden', '');
            } else {
                this.$cartPopupProductDetails.html(variantPropertiesHTML);
                this.$cartPopupProductDetails.removeAttr('hidden');
            }
        },

        _getVariantOptionList: function(variantOptions) {
            var variantOptionListHTML = '';

            variantOptions.forEach(function(variantOption) {
                variantOptionListHTML =
                    variantOptionListHTML +
                    '<li class="product-details__item product-details__item--variant-option">' +
                    variantOption.name +
                    ': ' +
                    variantOption.value +
                    '</li>';
            });

            return variantOptionListHTML;
        },

        _getPropertyList: function(properties) {
            var propertyListHTML = '';
            var propertiesArray = Object.entries(properties);

            propertiesArray.forEach(function(property) {                
                if (property[0].charAt(0) === '_') return;                
                if (property[1].length === 0) return;
                propertyListHTML =
                    propertyListHTML +
                    '<li class="product-details__item product-details__item--property">' +
                    '<span class="product-details__property-label">' +
                    property[0] +
                    ': </span>' +
                    property[1];
                ': ' + '</li>';
            });

            return propertyListHTML;
        },

        _setCartQuantity: function(quantity) {
            this.$cartPopupCartQuantity =
                this.$cartPopupCartQuantity || $(this.selectors.cartPopupCartQuantity);
            var ariaLabel;

            if (quantity === 1) {
                ariaLabel = theme.strings.oneCartCount;
            } else if (quantity > 1) {
                ariaLabel = theme.strings.otherCartCount.replace('[count]', quantity);
            }

            this.$cartPopupCartQuantity.text(quantity).attr('aria-label', ariaLabel);
        },

        _setCartCountBubble: function(quantity) {
            this.$cartCountBubble =
                this.$cartCountBubble || $(this.selectors.cartCountBubble);
            this.$cartCount = this.$cartCount || $(this.selectors.cartCount);

            this.$cartCountBubble.removeClass(this.classes.hidden);
            this.$cartCount.text(quantity);
        },

        _showCartPopup: function() {
            this.$cartPopupWrapper
                .prepareTransition()
                .removeClass(this.classes.cartPopupWrapperHidden);
            this._handleButtonLoadingState(false);

            slate.a11y.trapFocus({
                $container: this.$cartPopupWrapper,
                $elementToFocus: this.$cartPopup,
                namespace: 'cartPopupFocus'
            });
        },

        _hideCartPopup: function(event) {
            var setFocus = event.detail === 0 ? true : false;
            this.$cartPopupWrapper
                .prepareTransition()
                .addClass(this.classes.cartPopupWrapperHidden);

            $(this.selectors.cartPopupImage).remove();
            this.$cartPopupImagePlaceholder.removeClass(this.classes.hidden);

            slate.a11y.removeTrapFocus({
                $container: this.$cartPopupWrapper,
                namespace: 'cartPopupFocus'
            });

            if (setFocus) this.$previouslyFocusedElement[0].focus();

            this.$cartPopupWrapper.off('keyup');
            this.$cartPopupClose.off('click');
            this.$cartPopupDismiss.off('click');
            $('body').off('click');
        },

        _onBodyClick: function(event) {
            var $target = $(event.target);

            if (
                $target[0] !== this.$cartPopupWrapper[0] &&
                !$target.parents(this.selectors.cartPopup).length
            ) {
                this._hideCartPopup(event);
            }
        },

        _setActiveThumbnail: function(imageId) {            
            if (typeof imageId === 'undefined') {
                imageId = $(
                    this.selectors.productImageWraps + ':not(.hide)',
                    this.$container
                ).data('image-id');
            }

            var $thumbnailWrappers = $(
                this.selectors.productThumbListItem + ':not(.slick-cloned)',
                this.$container
            );

            var $activeThumbnail = $thumbnailWrappers.find(
                this.selectors.productThumbImages +
                "[data-thumbnail-id='" +
                imageId +
                "']"
            );

            $(this.selectors.productThumbImages)
                .removeClass(this.classes.activeClass)
                .removeAttr('aria-current');

            $activeThumbnail.addClass(this.classes.activeClass);
            $activeThumbnail.attr('aria-current', true);

            if (!$thumbnailWrappers.hasClass('slick-slide')) {
                return;
            }

            var slideIndex = $activeThumbnail.parent().data('slick-index');

            $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true);
        },

        _switchImage: function(imageId) {
            var $newImage = $(
                this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
                this.$container
            );
            var $otherImages = $(
                this.selectors.productImageWraps +
                ":not([data-image-id='" +
                imageId +
                "'])",
                this.$container
            );

            $newImage.removeClass(this.classes.hidden);
            $otherImages.addClass(this.classes.hidden);
        },

        _handleImageFocus: function(evt) {
            if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return;

            $(this.selectors.productFeaturedImage + ':visible').focus();
        },

        _initThumbnailSlider: function() {
            var options = {
                slidesToShow: 4,
                slidesToScroll: 3,
                infinite: false,
                prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
                nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
                responsive: [{
                    breakpoint: 321,
                    settings: {
                        slidesToShow: 3
                    }
                }]
            };

            $(this.selectors.productThumbs).slick(options);
            $(this.selectors.productThumbsWrapper, this.$container)
                .find('.slick-list')
                .removeAttr('aria-live');
            $(this.selectors.productThumbsWrapper, this.$container)
                .find('.slick-disabled')
                .removeAttr('aria-disabled');

            this.settings.sliderActive = true;
        },

        _destroyThumbnailSlider: function() {
            $(this.selectors.productThumbs).slick('unslick');
            this.settings.sliderActive = false;
            $(this.selectors.productThumbsWrapper, this.$container)
                .find('[tabindex="-1"]')
                .removeAttr('tabindex');
        },

        _liveRegionText: function(variant) {

            var liveRegionText =
                '[Availability] [Regular] [$$] [Sale] [$]. [UnitPrice] [$$$]';

            if (!variant) {
                liveRegionText = theme.strings.unavailable;
                return liveRegionText;
            }

            var availability = variant.available ? '' : theme.strings.soldOut + ',';
            liveRegionText = liveRegionText.replace('[Availability]', availability);


            var regularLabel = '';
            var regularPrice = theme.Currency.formatMoney(
                variant.price,
                theme.moneyFormat
            );
            var saleLabel = '';
            var salePrice = '';
            var unitLabel = '';
            var unitPrice = '';

            if (variant.compare_at_price > variant.price) {
                regularLabel = theme.strings.regularPrice;
                regularPrice =
                    theme.Currency.formatMoney(
                        variant.compare_at_price,
                        theme.moneyFormat
                    ) + ',';
                saleLabel = theme.strings.sale;
                salePrice = theme.Currency.formatMoney(
                    variant.price,
                    theme.moneyFormat
                );
            }

            if (variant.unit_price) {
                unitLabel = theme.strings.unitPrice;
                unitPrice =
                    theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat) +
                    ' ' +
                    theme.strings.unitPriceSeparator +
                    ' ' +
                    this._getBaseUnit(variant);
            }

            liveRegionText = liveRegionText
                .replace('[Regular]', regularLabel)
                .replace('[$$]', regularPrice)
                .replace('[Sale]', saleLabel)
                .replace('[$]', salePrice)
                .replace('[UnitPrice]', unitLabel)
                .replace('[$$$]', unitPrice)
                .trim();

            return liveRegionText;
        },

        _updateLiveRegion: function(evt) {
            var variant = evt.variant;
            var liveRegion = this.container.querySelector(
                this.selectors.productStatus
            );

        },

        _updateAddToCart: function(evt) {
            var variant = evt.variant;

            if (variant) {
                if (variant.available) {
                    this.$addToCart
                        .removeAttr('aria-disabled')
                        .attr('aria-label', theme.strings.addToCart);
                    $(this.selectors.addToCartText, this.$container).text(
                        theme.strings.addToCart
                    );
                    $(this.selectors.productForm, this.container).removeClass(
                        this.classes.variantSoldOut
                    );
                } else {                    
                    this.$addToCart
                        .attr('aria-disabled', true)
                        .attr('aria-label', theme.strings.soldOut);
                    $(this.selectors.addToCartText, this.$container).text(
                        theme.strings.soldOut
                    );
                    $(this.selectors.productForm, this.container).addClass(
                        this.classes.variantSoldOut
                    );
                }
            } else {
                this.$addToCart
                    .attr('aria-disabled', true)
                    .attr('aria-label', theme.strings.unavailable);
                $(this.selectors.addToCartText, this.$container).text(
                    theme.strings.unavailable
                );
                $(this.selectors.productForm, this.container).addClass(
                    this.classes.variantSoldOut
                );
            }
        },

        _updateAvailability: function(evt) {            
            this._hideErrorMessage();
            this._updateAddToCart(evt);
            this._updateLiveRegion(evt);
            this._updatePrice(evt);
        },

        _updateImages: function(evt) {
            var variant = evt.variant;
            var imageId = variant.featured_image.id;

            this._switchImage(imageId);
            this._setActiveThumbnail(imageId);
        },

        _updatePrice: function(evt) {
            var variant = evt.variant;

            var $priceContainer = $(this.selectors.priceContainer, this.$container);
            var $regularPrice = $(this.selectors.regularPrice, $priceContainer);
            var $salePrice = $(this.selectors.salePrice, $priceContainer);
            var $unitPrice = $(this.selectors.unitPrice, $priceContainer);
            var $unitPriceBaseUnit = $(
                this.selectors.unitPriceBaseUnit,
                $priceContainer
            );
            
            $priceContainer
                .removeClass(this.classes.productUnavailable)
                .removeClass(this.classes.productOnSale)
                .removeClass(this.classes.productUnitAvailable)
                .removeClass(this.classes.productSoldOut)
                .removeAttr('aria-hidden');

            this.$productPolicies.removeClass(this.classes.visibilityHidden);            
            if (!variant) {
                $priceContainer
                    .addClass(this.classes.productUnavailable)
                    .attr('aria-hidden', true);

                this.$productPolicies.addClass(this.classes.visibilityHidden);
                return;
            }

            if (!variant.available) {
                $priceContainer.addClass(this.classes.productSoldOut);
                return;
            }

            if (variant.compare_at_price > variant.price) {
                $regularPrice.html(
                    theme.Currency.formatMoney(
                        variant.compare_at_price,
                        theme.moneyFormat
                    )
                );
                $salePrice.html(
                    theme.Currency.formatMoney(variant.price, theme.moneyFormat)
                );
                $priceContainer.addClass(this.classes.productOnSale);
            } else {

                $regularPrice.html(
                    theme.Currency.formatMoney(variant.price, theme.moneyFormat)
                );
            }
            if (variant.unit_price) {
                $unitPrice.html(
                    theme.Currency.formatMoney(variant.unit_price, theme.moneyFormat)
                );
                $unitPriceBaseUnit.html(this._getBaseUnit(variant));
                $priceContainer.addClass(this.classes.productUnitAvailable);
            }
        },

        _getBaseUnit: function(variant) {
            return variant.unit_price_measurement.reference_value === 1 ?
                variant.unit_price_measurement.reference_unit :
                variant.unit_price_measurement.reference_value +
                variant.unit_price_measurement.reference_unit;
        },

        _updateSKU: function(evt) {
            var variant = evt.variant;
            $(this.selectors.SKU).html(variant.sku);
        },

        onUnload: function() {
            this.$container.off(this.settings.namespace);
        }
    });

    function _enableZoom(el) {
        var zoomUrl = $(el).data('zoom');
        $(el).zoom({
            url: zoomUrl
        });
    }

    function _destroyZoom(el) {
        $(el).trigger('zoom.destroy');
    }

    return Product;
})();

theme.ProductRecommendations = (function() {
    function ProductRecommendations(container) {
        this.$container = $(container);

        var baseUrl = this.$container.data('baseUrl');
        var productId = this.$container.data('productId');
        var recommendationsSectionUrl =
            baseUrl +
            '?section_id=product-recommendations&product_id=' +
            productId +
            '&limit=4';

        $.get(recommendationsSectionUrl).then(
            function(section) {
                var recommendationsMarkup = $(section).html();
                if (recommendationsMarkup.trim() !== '') {
                    this.$container.html(recommendationsMarkup);
                }
            }.bind(this)
        );
    }

    return ProductRecommendations;
})();
theme.Slidefashion = (function() {
    
    function Slidefashion(container) {
      var $container = (this.$container = $(container));
      var sectionId = $container.attr('data-section-id');
      var slider = (this.slider = '#Unislide-' + sectionId);
      var wrapper = (this.wrapper = '.slider-fashion-wrapper');
      var $slider = $(slider, wrapper);      

      jQuery('.slider-fashion').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        centerMode: true,
        variableWidth: true,
        infinite: true,
        focusOnSelect: true,
        cssEase: 'linear',
        touchMove: true,
    });

    var imgs = jQuery('.slider-fashion img');
    imgs.each(function() {
        var item = jQuery(this).closest('.slick-slide');
        item.css({
            'background-image': 'url(' + jQuery(this).attr('src') + ')',
            'background-position': 'center',
            '-webkit-background-size': 'cover',
            'background-size': 'cover',
        });
        jQuery(this).hide();
    });    
    }

    Slidefashion.prototype = _.assignIn({}, Slidefashion.prototype, {
        onBlockSelect: function(evt) {
          $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);          
        }
    });

    return Slidefashion;
})();

theme.Slidenavfor = (function() {
    
    function Slidenavfor(container) {
      var $container = (this.$container = $(container));
      var sectionId = $container.attr('data-section-id');
      var slider = (this.slider = '#Unislider-' + sectionId);
      var wrapper = (this.wrapper = '.unislider-wrapper');
      var $slider = $(slider, wrapper);      

      jQuery(".slide-for").slick({
        nextArrow: '<button  class="vk-arrow next"><i class="uni-icomoon icon-keyboard-arrow-right"></i></button>',
        prevArrow: '<button  class="vk-arrow prev"><i class="uni-icomoon icon-keyboard-arrow-left"></i></button>',
        adaptiveHeight: true,
        asNavFor: '.slide-nav'
      });
      jQuery(".slide-nav").slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        asNavFor: '.slide-for',
        dots: false,
        centerMode: false,
        focusOnSelect: true
      });      
    }

    Slidenavfor.prototype = _.assignIn({}, Slidenavfor.prototype, {
        onBlockSelect: function(evt) {
          $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);          
        }
    });

    return Slidenavfor;
})();

theme.Unislider = (function() {

    var config = {
        mediaQuerySmall: 'screen and (max-width: 991px)',
        mediaQueryMediumUp: 'screen and (min-width: 992px)',
        mediaQueryMob: 'screen and (max-width: 575px)',
        slideCount: 0
    };
    var defaults = {
        accessibility: true,
        arrows: true,
        dots: true,
        autoplay: false,
        touchThreshold: 20,
        slidesToShow: 3,
        slidesToScroll: 3,
        nextArrow: '<button  class="next slick-arrow"><i class="uni-icomoon icon-chevron-right"></i></button>',
        prevArrow: '<button  class="prev slick-arrow"><i class="uni-icomoon icon-chevron-left"></i></button>'
    };

    function Unislider(container) {

        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        var wrapper = (this.wrapper = '.unislider-wrapper');
        var slider = (this.slider = '#Unislider-' + sectionId);
        var $slider = $(slider, wrapper);

        var tabletcol = 3;
        var mobilecol = 1;

        if ($slider.data('tabletcol')) {
            tabletcol = $slider.data('tabletcol');
        }
        if ($slider.data('mobilecol')) {
            mobilecol = $slider.data('mobilecol');
        }

        var sliderActive = false;
        var mobileOptions = $.extend({}, defaults, {
            slidesToShow: tabletcol,
            slidesToScroll: tabletcol,
            adaptiveHeight: true
        });

        var mobilesOptions = $.extend({}, defaults, {
            slidesToShow: mobilecol,
            slidesToScroll: mobilecol,
            adaptiveHeight: true,
            arrows: false
        });

        config.slideCount = $slider.data('count');

        defaults.slidesToShow = config.slideCount;
        defaults.slidesToScroll = config.slideCount;

        var show_dots = $slider.data('dots');
        var show_arrows = $slider.data('arrows');


        if (show_dots == "yes") {
            defaults.dots = true;
        } else {
            defaults.dots = false;
        }

        if (show_arrows == "yes") {
            defaults.arrows = true;
        } else {
            defaults.arrows = false;
        }

        $slider.on('init', this.a11y.bind(this));

        enquire.register(config.mediaQuerySmall, {
            match: function() {
                initSlider($slider, mobileOptions);
            }
        });

        enquire.register(config.mediaQueryMob, {
            match: function() {
                initSlider($slider, mobilesOptions);
            }
        });

        enquire.register(config.mediaQueryMediumUp, {
            match: function() {
                initSlider($slider, defaults);
            }
        });

        function initSlider(sliderObj, args) {
            if (sliderActive) {
                sliderObj.slick('unslick');
                sliderActive = false;
            }

            sliderObj.slick(args);
            sliderActive = true;
        }
    }

    Unislider.prototype = _.assignIn({}, Unislider.prototype, {
        onUnload: function() {
            enquire.unregister(config.mediaQuerySmall);
            enquire.unregister(config.mediaQueryMediumUp);
            $(this.slider, this.wrapper).slick('unslick');
        },

        onBlockSelect: function(evt) {            
            var $slide = $(
                '.unislider-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
            );
            var slideIndex = $slide.data('slick-index');            
            $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
        },

        a11y: function(event, obj) {
            var $list = obj.$list;
            var $wrapper = $(this.wrapper, this.$container);            
            $list.removeAttr('aria-live');            
            $wrapper.on('focusin', function(evt) {
                if ($wrapper.has(evt.target).length) {
                    $list.attr('aria-live', 'polite');
                }
            });

            $wrapper.on('focusout', function(evt) {
                if ($wrapper.has(evt.target).length) {
                    $list.removeAttr('aria-live');
                }
            });
        }
    });

    return Unislider;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {
    function SlideshowSection(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        var slideshow = (this.slideshow = '#Slideshow-' + sectionId);

        theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId);
    }

    return SlideshowSection;
})();

theme.SlideshowSection.prototype = _.assignIn({},
    theme.SlideshowSection.prototype, {
        onUnload: function() {
            delete theme.slideshows[this.slideshow];
        },

        onBlockSelect: function(evt) {
            var $slideshow = $(this.slideshow);
            var adaptHeight = $slideshow.data('adapt-height');

            if (adaptHeight) {
                theme.slideshows[this.slideshow].setSlideshowHeight();
            }
            var $slide = $(
                '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
            );
            var slideIndex = $slide.data('slick-index');
            $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
        },

        onBlockDeselect: function() {
            $(this.slideshow).slick('slickPlay');
        }
    }
);

theme.slideshows = {};

theme.heros = {};

theme.HeroSection = (function() {
    function HeroSection(container) {
        var $container = (this.$container = $(container));
        var sectionId = $container.attr('data-section-id');
        var hero = '#Hero-' + sectionId;
        theme.heros[hero] = new theme.Hero(hero, sectionId);
    }

    return HeroSection;
})();

theme.MegaMenuSection = function() {
    function y(C) {
        var S = this.$container = $(C),
            I = S.attr("data-section-id"),
            T = S.attr("data-section-type");
        this.MegaMenu = $("#megamenu-" + I), this.megaMenuNamspace = "#megamenu-" + I, this.megaMenuId = $("#shopify-section-" + I), 0 < $(".section-megamenu-content").length && $(".section-megamenu-content").each(function() {
            var P = $(this).data("menu_width_class");
            0 < $(this).closest(".shopify-section").length && (!$(this).closest(".shopify-section").hasClass(P) && $(this).closest(".shopify-section").addClass(P), $(this).closest(".shopify-section").removeClass("hidden"))
        }), 0 < $("#header-phantom .shopify-section").length && $("#header-phantom .shopify-section").each(function() {
            $(this).removeClass("shopify-section")
        }), this._init()
    }
    return y.prototype = _.assignIn({}, y.prototype, {
        _init: function() {
            this._handleMegaMenu(), this._handleVermenuCategory()
        },

        _handleVermenuCategory: function() {
            if ($("#vermenu_cat_gap").length && 992 <= roar.getWidthBrowser() && 0 < $(".container-megamenu.vertical .paris-menu-wrap").length) {
                var C = $(".container-megamenu.vertical .paris-menu-wrap").outerHeight(),
                    S = $(".container-megamenu.vertical .paris-menu-wrap").offset().top,
                    I = $("#sidebar").offset().top;
                $("#vermenu_cat_gap").css("height", C - (I - S))
            }
        },
        _handleMegaMenu: function() {

            var C = this._handleVermenuCategory();
            "yes" == window.megamenu_responsive_design && 992 > $(window).width() && (window.megamenu_responsive = !0), $("ul.megamenu > li").each(function() {
                    var S = 0;
                    $(this).find(".mobile-enabled").each(function() {
                        S++
                    }), 0 == S && $(this).find(".open-sub").addClass("mobile-disabled")
                }), $("ul.megamenu li .sub-menu .content .hover-menu ul li").hover(function() {
                    $(this).children("ul").addClass("active")
                }, function() {
                    $(this).children("ul").removeClass("active")
                }), $(".close-categories").unbind("click"), $(".close-categories").on("click", function() {
                    return $(this).parent().removeClass("active"), $(this).next().animate({
                        height: "hide"
                    }, 400), !1
                }), $(".open-categories").unbind("click"), $(".open-categories").on("click", function() {
                    return $(".open-categories").parent().removeClass("active"), $(".open-categories").next().next().animate({
                        height: "hide"
                    }, 400), $(this).parent().addClass("active"), $(this).next().next().animate({
                        height: "show"
                    }, 400), !1
                }), $(".close-sub").unbind("click"), $(".close-sub").on("click", function() {
                    $(this).parent().removeClass("active");
                    $(this).css('display', 'none');
                    $(this).parent().find('.open-sub').css('display', 'block');
                }), $(".open-sub").unbind("click"), $(".open-sub").on("click", function() {
                    $("ul.megamenu > li").removeClass("active");
                    $(this).parent().addClass("active");
                    $(this).parents('.megamenu').find('.close-sub').css('display', 'none');
                    $(this).parents('.megamenu').find('.open-sub').css('display', 'block');
                    $(this).css('display', 'none');
                    $(this).prev().css('display', 'block');

                }),
                $("ul.megamenu > li.click .content a").unbind("click"), $("ul.megamenu > li.click .content a").click(function() {
                    window.location = $(this).attr("href")
                }), $("ul.megamenu > li.hover").hover(function() {
                    if (0 == window.megamenu_responsive) {
                        if (window.megamenu_active = $(this), window.megamenu_hover = !0, $("ul.megamenu > li").removeClass("active"), $(this).addClass("active"), window.rtl) {
                            $(this).children(".sub-menu").css("right", "auto"), $(this).children(".sub-menu").css("left", "auto");
                            var S = $(this).children(".sub-menu"),
                                I = S.offset().left,
                                T = $(".horizontal ul.megamenu"),
                                P = T.offset().left - 45;
                            P > I && $(this).children(".sub-menu").css("left", "0")
                        } else {
                            $(this).children(".sub-menu").css("right", "auto");
                            var S = $(this).children(".sub-menu"),
                                I = $(window).width() - (S.offset().left + S.outerWidth());
                            if ($(".header-type-3").length) var T = $("#top .container"),
                                P = $(window).width() - (T.offset().left + T.outerWidth());
                            else
                            if ($(".overflow-megamenu").length) {
                                var T = $(".overflow-megamenu"),

                                    P = $(window).width() - (T.offset().left + T.outerWidth());
                                P > I && $(this).children(".sub-menu").css("right", "0")
                            }

                        }
                        var z = $(this).children("a").outerWidth() / 2,
                            A = $(this).children("a").offset().left - $(this).find(".content").offset().left;
                        $(this).find(".content > .arrow").css("left", A + z)
                    }
                }, function() {
                    if (0 == window.megamenu_responsive) {
                        var S = $(this).attr("title");
                        if (window.megamenu_hover = !1, "hover-intent" == S) {
                            var I = $(this);
                            setTimeout(function() {
                                0 == window.megamenu_hover && $(I).removeClass("active")
                            }, 500)
                        } else $(this).removeClass("active")
                    }
                }), $("ul.megamenu > li.click").unbind("click"), $("ul.megamenu > li.click").click(function() {
                    if (1 == $(this).removeClass("active")) return !1;
                    if (window.megamenu_active = $(this), window.megamenu_hover = !0, $("ul.megamenu > li").removeClass("active"), $(this).addClass("active"), 1 == window.megamenu_responsive && $(this).children(".sub-menu").animate({
                            height: "show"
                        }, 400), window.rtl) {
                        $(this).children(".sub-menu").css("right", "auto"), $(this).children(".sub-menu").css("left", "auto");
                        var S = $(this).children(".sub-menu"),
                            I = S.offset().left,
                            T = $(".horizontal ul.megamenu"),
                            P = T.offset().left - 45;
                        P > I && $(this).children(".sub-menu").css("left", "0")
                    } else {
                        $(this).children(".sub-menu").css("right", "auto");
                        var S = $(this).children(".sub-menu"),
                            I = $(window).width() - (S.offset().left + S.outerWidth());
                        if ($(".header-type-3").length) var T = $("#top .container"),
                            P = $(window).width() - (T.offset().left + T.outerWidth());
                        else var T = $(".overflow-megamenu"),
                            P = $(window).width() - (T.offset().left + T.outerWidth());
                        P > I && $(this).children(".sub-menu").css("right", "0")
                    }
                    var z = $(this).children("a").outerWidth() / 2,
                        A = $(this).children("a").offset().left - $(this).find(".content").offset().left;
                    return $(this).find(".content > .arrow").css("left", A + z), !1
                }), $(".categories-image-right ul > li > a").hover(function() {
                    $(this).closest(".categories-image-right").find("img").attr("src", $(this).attr("data-image"))
                }, function() {
                    var S = $(this).closest(".categories-image-right").attr("data-image");
                    $(this).closest(".categories-image-right").find("img").attr("src", S)
                }), $(".paris-menu-toggle").unbind("click"), $(".paris-menu-toggle").click(function() {
                    return 1 == $(this).removeClass("active") ? $(this).parent().find(".paris-menu-wrap").stop(!0, !0).animate({
                        height: "hide"
                    }, 400) : ($(this).parent().find(".paris-menu-wrap").stop(!0, !0).animate({
                        height: "toggle"
                    }, 400), $(this).addClass("active")), !1
                }), $("html").unbind("click"), $("html").on("click", function() {
                    "yes" == window.megamenu_responsive_design && 992 > $(window).width() || $("ul.megamenu > li.click").removeClass("active")
                }), C, $(window).resize(function() {
                    window.megamenu_responsive = !1, "yes" == window.megamenu_responsive_design && 992 > $(window).width() && (window.megamenu_responsive = !0), C
                })
        },
        onUnload: function() {
            this.$container.off(this.megaMenuNamspace)
        },
        onSelect: function() {},
        onBlockSelect: function() {},
        onBlockDeselect: function() {}
    }), y
}();

$(document).ready(function() {
    univer.init();
    var sections = new theme.Sections();

    sections.register('cart-template', theme.Cart);
    sections.register('product', theme.Product);
    sections.register('collection-template', theme.Filters);
    sections.register('product-template', theme.Product);
    sections.register('slideshow-section', theme.SlideshowSection);
    sections.register('hero-section', theme.HeroSection);
    sections.register('product-recommendations', theme.ProductRecommendations);
    sections.register('unislider', theme.Unislider);
    sections.register('unislidernavfor', theme.Slidenavfor);
    sections.register('unisliderfashion', theme.Slidefashion);
    sections.register('mega-menu', theme.MegaMenuSection);

    $('.header-search-wrap-popup').click(function () {
            $(this).find('.inner-search-wrap').addClass('fix-serach');
            $(this).find('.inner-search-wrap').css({"display" : "block"});
            $(this).find('.search-form').addClass('visible');
            $('.close-search').css({"display" : "block"});
        });
        $('.close-search').click(function() {
                $(this).css({"display" : "none"});
                $('.inner-search-wrap').removeClass('fix-serach');
                $('.inner-search-wrap').css({"display" : "none"});
                $('.search-form').removeClass('visible');
        });

 
    var submitIcon = $('.expicon');
                var submitInput = $('.expinput');
                var searchBox = $('.exp-serach');
                var isOpen = false;
                
                $(document).mouseup(function(){
                    if(isOpen == true){
                    submitIcon.click();
                    }
                });
                
                submitIcon.mouseup(function(){
                    return false;
                });
                
                searchBox.mouseup(function(){
                    return false;
                });
                        
                submitIcon.click(function(){
                    if(isOpen == false){
                        searchBox.addClass('exp-serach-open');
                        isOpen = true;
                    } else {
                        searchBox.removeClass('exp-serach-open');
                        isOpen = false;
                    }
            });

    $('.scroller').on('click', function() {
        var cls = $(this).next().offset().top;
        $("html, body").animate({ scrollTop: cls }, "slow");
    });
    $('.slide-scroller').on('click', function() {
        var cls = $(this).parents('.index-section--slideshow').next().offset().top;
        $("html, body").animate({ scrollTop: cls }, "slow");
    });
    
    jQuery('.header-fashion .navbar-fashion').on('click', function() {

        jQuery(this).parent().find('.paris-menu-wrap').addClass("selected");
        jQuery(this).hide();
        jQuery(this).parent().find('.navbar-fashion-close').show();
    });
    jQuery('.header-fashion .navbar-fashion-close').on('click', function() {

        jQuery(this).parent().find('.paris-menu-wrap').removeClass("selected");
        jQuery(this).hide();
        jQuery(this).parent().find('.navbar-fashion').show();
    });
    jQuery('#uni-menu-toggle').on('click', function() {
        var wah = '0';
        jQuery(this).parent().find('.ca-main-menu')
            .css({
                'top': wah + 'px',
            })
            .addClass('mobile-is-active');

        jQuery(this).parent().find('.mobile-overlay-menu').show();
        jQuery('body').css('overflow', 'hidden');
        jQuery(this).parent().find('.mobile-overlay-menu').on('click', function() {
            jQuery(this).parent().find('.ca-main-menu').removeClass('mobile-is-active');
            jQuery(this).hide();
            jQuery('body').css('overflow', 'auto');
        });

    });
    jQuery('#uni-close-menu').on('click', function() {
        jQuery(this).parents('.ca-main-menu').removeClass('mobile-is-active');
        jQuery(this).parents('.left-menu-wrap').find('.mobile-overlay-menu').hide();
        jQuery('body').css('overflow', 'auto');
    });

    jQuery('#close-mobile-menu').on('click', function () {
            jQuery(this).parents('.mobile-left').removeClass('mobile-is-active');
            jQuery(this).parents('.uni-menu-mobile').find('.mobile-overlay-menu').hide();
            jQuery('body').css('overflow', 'auto');
        });  

    jQuery('#uni-menu-toggle-m').on('click', function() {
        var wah = '0';
        jQuery(this).parent().find('.mobile-left')
            .css({
                'top': wah + 'px',
            })
            .addClass('mobile-is-active');
        jQuery(this).addClass('mactive');
        jQuery(this).parent().find('.mobile-overlay-menu').show();
        jQuery('body').css('overflow', 'hidden');
        jQuery(this).parent().find('.mobile-overlay-menu').on('click', function() {
            jQuery(this).parent().find('.mobile-left').removeClass('mobile-is-active');
            jQuery(this).parent().find('#uni-menu-toggle-m').removeClass('mactive');
            jQuery(this).hide();
            jQuery('body').css('overflow', 'auto');
        });

    });
    jQuery('#uni-close-menu').on('click', function() {
        jQuery(this).parents('.mobile-left').removeClass('mobile-is-active');
        jQuery(this).parents('.left-menu-wrap').find('.mobile-overlay-menu').hide();
        jQuery('body').css('overflow', 'auto');
    });

    jQuery(".lastword").html(function() {
        var text = jQuery(this).text().trim().split(" ");
        var last = text.pop();
        return text.join(" ") + (text.length > 0 ? " <span class='vk-lastword'>" + last + "</span>" : last);
    });

    jQuery(".firstword").html(function() {
        var text = jQuery(this).text().trim().split(" ");
        var first = text.shift();
        return (text.length > 0 ? "<span class='vk-firstword'>" + first + "</span> " : first) + text.join(" ");
    });
    
    /*Tab Detail Course*/
    jQuery(".univer-tab-menu> a").on('click', function(e) {
        e.preventDefault();
        jQuery(this).siblings('a.active').removeClass("active");
        jQuery(this).addClass("active");
        var index = jQuery(this).index();
        jQuery("div.univer-tab>div.univer-tab-content").removeClass("active");
        jQuery("div.univer-tab>div.univer-tab-content").eq(index).addClass("active");
    });
    jQuery('.search-click .icon-search').on('click', function(event) {
        jQuery('.search-click .icon-search').hide();
        jQuery('.search-click .icon-remove').css('display', 'inline-block');
        jQuery('.search-click').addClass('search-active');
        jQuery('.search-f').css('display', 'inline-block');
    });
    jQuery('.search-click .icon-remove').on('click', function(event) {

        jQuery('.search-click .icon-remove').hide();

        jQuery('.search-f').hide();
        jQuery('.search-click').removeClass('search-active');
        jQuery('.search-click .icon-search').css('display', 'inline-block');

    });
    jQuery(".i-has-children").on('click', function() {
        var e = jQuery(this);
        var a = e.parent();
        var i = e.parent().find(" > .sub-menu:first");

        a.hasClass("active-submenu") ? (i.stop(!0, !0).slideUp(),
            a.removeClass("active-submenu")) : (i.stop(!0, !0).slideDown(),
            a.addClass("active-submenu"))
    });
    var archive = jQuery('.vk-list-item-shop');
    if (archive.length > 0) {
        jQuery(document).on('click', '.univer-switch > a', function(event) {
            var elem = jQuery(this),
                archive = jQuery('.vk-list-item-shop');
            event.preventDefault();
            if (!elem.hasClass('switch-active')) {
                jQuery('.univer-switch > a').removeClass('switch-active');
                elem.addClass('switch-active');
                if (elem.hasClass('switchToGrid')) {
                    archive.removeClass('univer-layout-list').addClass(' univer-layout-grid').fadeIn(300);

                } else {
                    archive.removeClass('univer-layout-grid').addClass('univer-layout-list').fadeIn(300);

                }
            }
        });
    }
    jQuery('[data-countdown]').each(function() {
        var $this = jQuery(this),
            finalDate = jQuery(this).data('countdown');
        $this.countdown(finalDate, function(event) {
            $this.find('.uni-days > span').html(event.strftime('%D'));
            $this.find('.uni-hours > span').html(event.strftime('%H'));
            $this.find('.uni-mins > span').html(event.strftime('%M'));
            $this.find('.uni-secs > span').html(event.strftime('%S'));
        });
    });
    jQuery('.vk-slider-shop.vertical .product-single__thumbnails').each(function() {
        jQuery(this).slick({
            nextArrow: '<button  class="vk-btn-gallery next"><i class="uni-icomoon icon-arrow-down"></i></button>',
            prevArrow: '<button  class="vk-btn-gallery prev"><i class="uni-icomoon icon-arrow-up"></i></button>',
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            focusOnSelect: true,
            vertical: true,
            responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: false,
                        vertical: false,
                        dots: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        vertical: false,
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: false,
                        dots: true,
                    }
                }

            ]
        });
    });
    jQuery('.vk-slider-shop.horizontal .product-single__thumbnails').each(function() {
        jQuery(this).slick({
            nextArrow: '<button  class="vk-btn-gallery next"><i class="uni-icomoon icon-arrow-right"></i></button>',
            prevArrow: '<button  class="vk-btn-gallery prev"><i class="uni-icomoon icon-arrow-left"></i></button>',
            speed: 300,
            slidesToShow: 5,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            focusOnSelect: true,
            responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        arrows: false,

                        dots: true,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: false,
                        dots: true,
                    }
                }
            ]
        });
    });
});